import React, { createContext, useContext, useState, useCallback } from 'react';
import EN_TEXTS from './i18n_en';

// ── Wielojezycznosc (i18n) ───────────────────────────────────────────────────
// Fundament pod tlumaczenia. UCZCIWIE: interfejs ma setki stringow rozsianych po
// calym App.js -- tlumaczymy je PRZYROSTOWO. Ten modul daje mechanizm i pokrywa
// najbardziej widoczna warstwe (nawigacja, naglowki, przyciski wspolne).
//
// Zasada: t('klucz') zwraca tlumaczenie; BRAK klucza -> zwracamy sam klucz
// (a nie pusty string ani crash), wiec nieprzetlumaczony fragment po prostu
// zostaje po polsku zamiast znikac. To celowe: aplikacja nigdy sie nie psuje
// przez brakujace tlumaczenie.

const TRANSLATIONS = {
  pl: {
    // Nawigacja -- grupy
    'nav.dashboard': '🏠 Pulpit',
    'nav.logger': '🎙 Logger',
    'nav.journal': '📒 Log',
    'nav.live': '📡 Na żywo',
    'nav.awards': '🏆 Dyplomy',
    'nav.info': 'ℹ️ Info',
    'nav.community': '🤝 Społeczność',
    'nav.tools': '🛠️ Narzędzia',
    'nav.admin': '🛠️ Admin',
    'nav.moderation': '🛡️ Moderacja',
    // Nawigacja -- pozycje
    'nav.logbook': '📖 Dziennik QSO',
    'nav.qsomap': '🗺️ Mapa QSO',
    'nav.stats': '📊 Statystyki',
    'nav.goals': '🏆 Cele i odznaki',
    'nav.portable': '⛺ Portable / POTA',
    'nav.dxccmap': '🌏 Mapa DXCC',
    'nav.analysis': '📈 Analiza czasowa',
    'nav.shared': '👥 Wspólny dziennik',
    'nav.eqsl': '🎨 Projekt karty eQSL',
    'nav.cluster': '🌐 DX Cluster',
    'nav.dxneeded': '🎯 Łowca braków',
    'nav.watchlist': '⭐ Watchlist',
    'nav.pota': '🏞️ POTA/SOTA',
    'nav.wwff': '🌲 WWFF',
    'nav.pskreporter': '📶 Kto mnie słyszy',
    'nav.satellites': '🛰️ Satelity',
    'nav.websdr': '🎧 WebSDR',
    'nav.svxlink': '🔊 SVXLink',
    'nav.weather': '🌦️ Pogoda',
    'nav.propagation': '☀️ Propagacja HF',
    'nav.activationplanner': '🏕️ Planer aktywacji',
    'nav.aprs': '📍 APRS',
    'nav.diplomas': '🏆 Dyplomy',
    'nav.news': '📰 Wiadomości',
    'nav.contests': '🏁 Zawody',
    'nav.dxpeditions': '✈️ Ekspedycje DX',
    'nav.mostwanted': '💎 Most Wanted',
    'nav.neighbors': '🏘️ Sąsiedzi',
    'nav.nets': '📋 Prowadzenie sieci',
    'nav.antenna': '📐 Kalkulator anten',
    'nav.cwdecoder': '🔤 Dekoder CW',
    'nav.cwtrainer': '🎓 Trenażer CW',
    'nav.pathcalc': '📏 Kalkulator trasy DX',
    'nav.qsorate': '⏱️ Tempo QSO',
    'nav.results': '🏅 Wyniki',
    'nav.qsl': '📨 QSL',
    'nav.plan': '📅 Plan',
    'nav.upload': '📤 Wysyłka do serwisów',
    'nav.qslpaper': '📇 QSL papierowe',
    'nav.trash': '🗑️ Kosz',
    'nav.mypropagation': '🧭 Moja propagacja',
    'nav.station': '🎛️ Mój sprzęt',
    'nav.year': '🎉 Podsumowanie roku',
    'nav.swl': '👂 Nasłuchy (SWL)',
    'nav.skeds': '⏰ Skedy',
    'nav.dxccmatrix': '🔢 Tabela DXCC',
    'nav.azimuthal': '🔭 Mapa azymutalna',
    'nav.bandmap': '📊 Mapa pasma',
    'nav.keyer': '📣 Klucz głosowy/CW',
    'nav.beacons': '📡 Beacony NCDXF', 'nav.alertrules': '🔔 Reguły alertów', 'nav.chat': '💬 Czat', 'nav.market': '🛒 Giełda sprzętu', 'nav.ranking': '🥇 Ranking', 'nav.exam': '🎓 Egzamin UKE',
    'nav.liveroster': '📻 Live Roster', 'nav.agentdiag': '🩺 Diagnostyka agenta', 'nav.wsjtx': '🎛️ WSJT-X — pilot',
    // Wspolne przyciski / etykiety
    'common.save': 'Zapisz',
    'common.cancel': 'Anuluj',
    'common.delete': 'Usuń',
    'common.edit': 'Edytuj',
    'common.refresh': 'Odśwież',
    'common.loading': 'Ładowanie...',
    'common.search': 'Szukaj',
    'common.close': 'Zamknij',
    'common.confirm': 'Potwierdź',
    'common.all': 'Wszystkie',
    'common.none': 'Brak',
    'common.logout': 'Wyloguj',
    // Logger
    'logger.activating': 'Aktywujesz',
    'logger.endActivation': 'Zakończ aktywację',
    'logger.newQso': '🎙 Nowe QSO',
    'logger.callsign': 'Znak',
    'logger.frequency': 'Częstotliwość (MHz)',
    'logger.mode': 'Emisja',
    'logger.band': 'Pasmo',
    'logger.rstSent': 'RST nadany',
    'logger.rstRecv': 'RST odebrany',
    'logger.name': 'Imię',
    'logger.qth': 'QTH',
    'logger.date': 'Data',
    'logger.country': 'Kraj',
    'logger.grid': 'Lokator',
    'logger.notes': 'Notatki',
    'logger.power': 'Moc (W)',
    'logger.saveQso': 'Zapisz QSO',
    'logger.workingAs': '📻 Pracuję jako',
    'logger.ownCallsign': '(własny)',
    'logger.recentQsos': 'Ostatnie QSO',
    'logger.sessionQsos': 'QSO',
    // Statystyki / dyplomy
    'awards.progress': '🏅 Postęp w dyplomach',
    'awards.missing': 'brakuje',
    'awards.hideMissing': 'ukryj braki',
    'awards.missingZones': 'Brakujące strefy CQ',
    'awards.missingStates': 'Brakujące stany USA',
    'awards.fiveBandDxcc': 'DXCC na pięciu pasmach (80/40/20/15/10 m)',
    'awards.countriesAllFive': 'krajów na wszystkich 5',
    // Logger -- rozszerzone
    'logger.editQso': '✏️ Edytuj',
    'logger.duplicate': 'Masz już QSO z tą stacją dzisiaj na tym paśmie/modzie',
    'logger.newCountry': 'NOWY KRAJ',
    'logger.newBand': 'nowe pasmo',
    'logger.newMode': 'nowa emisja',
    'logger.workedBefore': 'Masz już',
    'logger.times': 'razy',
    'logger.qrzLookup': 'Szukaj w QRZ',
    'logger.distance': 'Odległość',
    'logger.bearing': 'Namiar',
    // Dziennik
    'logbook.title': '📒 Dziennik',
    'logbook.search': 'Szukaj znaku...',
    'logbook.allBands': 'Wszystkie pasma',
    'logbook.allModes': 'Wszystkie emisje',
    'logbook.export': 'Eksport ADIF',
    'logbook.import': 'Import ADIF',
    'logbook.selected': 'Zaznaczono',
    'logbook.deselect': 'Odznacz',
    'logbook.noQsos': 'Brak łączności w dzienniku',
    // Statystyki
    'stats.total': 'Wszystkie QSO',
    'stats.unique': 'Unikalne znaki',
    'stats.countries': 'Kraje',
    'stats.bands': 'Pasma',
    'stats.modes': 'Emisje',
    // QSL
    'qsl.title': 'QSL papierowe',
    'qsl.toSend': 'Do wysłania',
    'qsl.awaiting': 'Czekam',
    'qsl.received': 'Odebrane',
    'qsl.bureau': '📮 Biuro',
    'qsl.direct': 'Direct',
    'qsl.manager': '👤 Manager',
    'qsl.labels': 'Etykiety',
    'qsl.cards': 'Karty QSL',
    'qsl.print': 'Drukuj',
    'qsl.markSent': 'Oznacz wysłane',
    'qsl.markReceived': '📬 Oznacz odebrane',
    // Bledy / komunikaty
    'error.generic': 'Wystąpił błąd',
    'error.network': 'Błąd połączenia',
    'error.notFound': 'Nie znaleziono',
    'msg.saved': 'Zapisano',
    'msg.deleted': 'Usunięto',
    'msg.updated': 'Zaktualizowano',
    // Admin / moderacja
    'admin.users': 'Użytkownicy',
    'admin.settings': 'Ustawienia',
    'admin.overview': 'Przegląd',
    'admin.announcements': 'Ogłoszenia',
    'admin.activityLog': 'Log aktywności',
    'admin.backups': 'Backupy',
    'admin.role': 'Rola',
    'admin.status': 'Status',
    'admin.actions': 'Akcje',
    'admin.suspend': '⛔ Zawieś',
    'admin.unsuspend': '✅ Odwieś',
    'admin.active': '✅ Aktywne',
    'admin.suspended': '⛔ Zawieszone',
    // Na zywo
    'live.spots': 'Spoty',
    'live.activator': 'Aktywator',
    'live.spotter': 'Spotter',
    'live.comment': 'Komentarz',
    'live.freq': 'Częstotliwość',
    'live.noSpots': 'Brak aktywnych spotów',
    // Dyplomy / spolecznosc
    'community.neighbors': 'Sąsiedzi',
    'community.sharedLog': 'Wspólny dziennik',
    'community.distance': 'Odległość',
    // 2FA
    '2fa.title': 'Uwierzytelnianie dwuskładnikowe (2FA)',
    '2fa.enable': 'Włącz 2FA',
    '2fa.disable': 'Wyłącz 2FA',
    '2fa.code': 'Kod 2FA',
    '2fa.backupCodes': 'Kody zapasowe',
    // Kontrola jakosci
    'health.title': '🩺 Kontrola jakości logu',
    'health.scan': 'Sprawdź log',
    'health.clean': 'Log jest czysty',
    'health.issues': 'problemów',
    // QSL -- pelne
    'qsl.desc': 'Obieg papierowej karty: oznacz QSO do wysyłki, wybierz drogę (biuro/direct), wydrukuj etykiety, a po odpowiedzi oznacz jako odebrane.',
    'qsl.allRoutes': 'Wszystkie drogi',
    'qsl.route': 'Droga',
    'qsl.unqueue': '✕ Usuń z kolejki',
    'qsl.emptyToSend': 'Brak QSO w kolejce. Dodaj je z dziennika (zaznacz QSO → „QSL do wysłania").',
    'qsl.emptyAwaiting': 'Nic nie czeka na odpowiedź.',
    'qsl.emptyReceived': 'Brak odebranych kart.',
    'qsl.labelsTitle': 'Etykiety QSL',
    'qsl.labelsDesc': 'Jedna etykieta = jedna stacja (kilka łączności z tym samym operatorem mieści się na jednej karcie).',
    'qsl.cardsTitle': 'Karty QSL do druku',
    'qsl.cardsDesc': 'Wygląd karty jak w Twoim projekcie eQSL (kolory, tło, klub, slogan) -- ustaw go w zakładce "Projekt eQSL", jeśli jeszcze tego nie zrobiłeś.',
    'qsl.back': '← Wróć',
    'qsl.sentDate': 'Wysłano',
    'qsl.recvDate': 'Odebrano',
    'qsl.selectFirst': 'Zaznacz najpierw QSO',
    'qsl.noQueue': 'Brak QSO w kolejce do wysyłki',
    // Kontrola jakosci -- pelne
    'health.desc': 'Wykrywa błędy blokujące dyplomy i LoTW. Warto uruchomić przed wysyłką.',
    'health.scanning': 'Skanowanie...',
    'health.cleanMsg': 'Log jest czysty — nie znaleziono problemów!',
    'health.cleanFull': 'Log jest czysty — przeskanowano {n} QSO, nie znaleziono problemów.',
    'health.foundIssues': 'Znaleziono',
    'health.inQsos': 'w',
    'health.clickCategory': 'Kliknij kategorię, aby zobaczyć szczegóły.',
    'health.failed': 'Nie udało się sprawdzić logu',
    'health.freqBandMismatch': 'Częstotliwość nie pasuje do pasma',
    'health.freqBandMismatchHint': 'Pasmo w logu nie zgadza się z częstotliwością — popraw pasmo (edycja masowa).',
    'health.freqOutOfBand': 'Częstotliwość poza pasmami amatorskimi',
    'health.freqOutOfBandHint': 'Prawdopodobnie literówka przy wpisywaniu.',
    'health.badGrid': 'Nieprawidłowy lokator',
    'health.badGridHint': 'Zły format blokuje dyplomy VUCC i obliczanie odległości.',
    'health.missingCountry': 'Brak kraju (nie liczy się do DXCC)',
    'health.missingCountryHint': 'Uzupełnij kraj — QSO bez kraju nie liczy się do DXCC.',
    'health.futureDate': 'Data QSO w przyszłości',
    'health.futureDateHint': 'Błąd wpisu lub importu — LoTW odrzuci takie QSO.',
    'health.duplicates': 'Możliwe duplikaty',
    'health.duplicatesHint': 'Ten sam znak, pasmo i emisja w ciągu 5 minut.',

    'myprop.continentEU': 'Europa',
    'myprop.continentNA': 'Ameryka Pn.',
    'myprop.continentSA': 'Ameryka Pd.',
    'myprop.continentAS': 'Azja',
    'myprop.continentAF': 'Afryka',
    'myprop.continentOC': 'Oceania',
    'myprop.confHigh': 'wiarygodne — duża próbka',
    'myprop.confMedium': 'orientacyjne — średnia próbka',
    'myprop.confLow': 'ostrożnie — mała próbka',
    'myprop.confNotEnough': 'za mało łączności, by cokolwiek wnioskować',
    'myprop.errLoad': 'Nie udało się pobrać analizy',
    'myprop.title': 'Osobista propagacja',
    'myprop.desc': 'Modele propagacyjne mówią, co powinno działać przy założeniach typowej stacji. Ten widok pokazuje, co faktycznie zadziałało -- z Twojej anteny, z Twojego QTH, z Twoją mocą. To zapis historii, nie prognoza -- ale po roku logowania bywa celniejszy niż model.',
    'myprop.tabNow': 'Co bywa otwarte teraz',
    'myprop.tabTarget': 'Kiedy robię konkretny cel',
    'myprop.utcHour': 'Godzina UTC',
    'myprop.now': 'Teraz',
    'myprop.calculating': '⏳ Liczenie...',
    'myprop.noQsosWindow': 'Brak łączności w tym oknie czasowym. Spróbuj innej godziny -- albo po prostu masz jeszcze mało danych o tej porze.',
    'myprop.qsosFromWindow': 'Twoje łączności z okna',
    'myprop.selectTarget': '— wybierz kraj z Twojego logu —',
    'myprop.qsosInLog': 'łączności w logu',
    'myprop.bestHours': 'Najlepsze godziny:',
    'myprop.band': 'Pasmo',
    'myprop.heatmapNote': 'Liczby to Twoje udane łączności w danej godzinie UTC. Jasne pola = pory, o których realnie tam docierasz.',
    'myprop.noQsosTarget': 'Brak łączności z tym celem.',

    'sessions.justNow': 'przed chwilą',
    'sessions.minAgo': 'min temu',
    'sessions.hoursAgo': 'godz. temu',
    'sessions.daysAgo': 'dni temu',
    'sessions.title': 'Gdzie jestem zalogowany',
    'sessions.desc': 'Lista urządzeń, z których logowano się na Twoje konto. Jeśli widzisz coś, czego nie rozpoznajesz — zmień hasło i wyloguj wszędzie.',
    'sessions.noSessions': 'Brak zapisanych sesji.',
    'sessions.thisSession': '● TA SESJA',
    'sessions.logoutAll': 'Wyloguj ze wszystkich urządzeń',
    'sessions.confirmTitle': 'Wylogować ze wszystkich urządzeń?',
    'sessions.confirmDesc': 'Wszystkie sesje (także ta) zostaną zamknięte. Trzeba będzie zalogować się ponownie. Potwierdź hasłem.',
    'sessions.passwordPlaceholder': 'Twoje hasło',
    'sessions.confirm': 'Potwierdź',
    'sessions.cancel': 'Anuluj',
    'sessions.loggedOutAll': 'Wylogowano ze wszystkich urządzeń',
    'sessions.errGeneric': 'Błąd',

    'ant.gardenGarden': '🌳 Ogród',
    'ant.gardenRooftop': '🏢 Dach',
    'ant.gardenBalcony': '🏠 Balkon',
    'ant.gardenAttic': '🏚️ Strych',
    'ant.errLoadCalc': 'Nie udało się załadować danych kalkulatora',
    'ant.bands': 'Pasma',
    'ant.spaceType': 'Typ przestrzeni',
    'ant.supports': 'Punkty zawieszenia',
    'ant.power': 'Moc (W)',
    'ant.hasTrees': 'Mam drzewa (punkty zaczepienia)',
    'ant.stealthReq': 'Wymagana dyskrecja (stealth)',
    'ant.calculating': '⏳ Liczę...',
    'ant.calcAntennas': 'Oblicz anteny',
    'ant.selectOneBand': 'Wybierz co najmniej jedno pasmo',
    'ant.errCalc': 'Błąd obliczeń',
    'ant.tabResults': 'Wyniki',
    'ant.tabTerrainMap': 'Mapa terenu',
    'ant.tabViz': 'Wizualizacja',
    'ant.tabCoax': 'Kabel/Fider',
    'ant.engineDesc': 'Silnik oceni typy anten (dipol, Inverted-V, EFHW, pionowa, pętle, Yagi...) pod kątem Twoich ograniczeń i policzy wymiary.',
    'ant.feed': 'Zasilanie:',
    'ant.noVizForType': 'Brak wizualizacji dla tego typu.',
    'ant.selectAntennaViz': 'Wybierz antenę w zakładce „Wyniki”, aby zobaczyć wizualizację wymiarów.',
    'ant.cableType': 'Typ kabla',
    'ant.swrAtAntenna': 'SWR na antenie',
    'ant.matchedLoss': 'Strata dopasowana',
    'ant.hintStandingWave': 'z uwzględnieniem grzania od fali stojącej',
    'ant.powerAtAntenna': 'Moc na antenie',
    'ant.powerLoss': 'Strata mocy',
    'ant.swrAtTx': 'SWR u nadajnika',
    'ant.hintLowerSwr': 'niższe niż na antenie — kabel maskuje SWR stratą',
    'ant.recommendation': 'Rekomendacja:',
    'ant.cableComparison': 'Porównanie kabli',
    'ant.cable': 'Kabel',
    'ant.lossDb': 'Strata (dB)',
    'ant.powerAtAntennaW': 'Moc na antenie (W)',
    'ant.errCoaxCalc': 'Błąd obliczeń kabla',
    'ant.calculateBtn': '🔌 Oblicz',
    'ant.errLocationNotFound': 'Nie znaleziono lokalizacji',
    'ant.errSearch': 'Błąd wyszukiwania',
    'ant.searchBtn': 'Szukaj',
    'ant.elevation': 'Wysokość:',
    'ant.noDataShort': 'brak danych',
    'ant.aboveSeaLevel': 'm n.p.m.',

    'pota.activeSpots': 'Aktywne spoty',
    'pota.errSpots': 'Błąd pobierania spotów POTA',
    'pota.errConnection': 'Błąd połączenia z API POTA',
    'pota.countryPL': 'Polska', 'pota.countryAll': 'Wszystkie kraje',
    'pota.countryDE': 'Niemcy', 'pota.countryCZ': 'Czechy', 'pota.countrySK': 'Slowacja',
    'pota.countryUA': 'Ukraina', 'pota.countryLT': 'Litwa', 'pota.countryAT': 'Austria',
    'pota.countryIT': 'Italia', 'pota.countryFR': 'Francja', 'pota.countryES': 'Hiszpania',
    'pota.countryGB': 'W. Brytania', 'pota.countryUS': 'USA',
    'pota.source': 'Źródło: api.pota.app (publiczne API)',
    'pota.refresh': '↻ Odśwież',
    'pota.noActive': 'Brak aktywnych aktywacji',
    'pota.noActiveForCountry': 'dla kraju',
    'pota.rightNow': 'w tej chwili',
    'pota.activator': 'Aktywator',
    'pota.comment': 'Komentarz',
    'pota.logBtn': 'Log',
    'pota.qsyTitle': 'Nastaw radio na ta częstotliwość (wymaga agenta CAT)',
    'pota.loadingStats': '⏳ Ładowanie statystyk...',
    'pota.errStats': 'Błąd pobierania statystyk POTA',
    'pota.fieldActivations': 'Aktywacje',
    'pota.fieldActivatorQsos': 'QSO (activator)',
    'pota.fieldActivatorParks': 'Unikalne parki (activator)',
    'pota.fieldHunterQsos': 'QSO (hunter)',
    'pota.fieldHunterParks': 'Unikalne parki (hunter)',
    'pota.fieldEndorsements': 'Wyroznienia',
    'pota.officialStats': 'Oficjalne statystyki POTA',
    'pota.officialStatsInfo': 'POTA udostępnia publicznie tylko zbiorcze liczby. Szczegolowa historia "który park, kiedy" wymaga zalogowania się na',
    'pota.officialStatsInfo2': 'i ręcznego eksportu -- nie da się tego pobrać dla zewnetrznej aplikacji bez Twojego logowania na ich stronie. Zamiast tego nizej pokazujemy podsumowanie zbudowane z',
    'pota.yourLogSummary': 'Twojego własnego logu w HamLoggerze',
    'pota.fromYourLog': '📒 Z Twojego logu HamLoggera',
    'pota.qsosWithRef': 'QSO z referencja POTA:',
    'pota.uniqueParks': 'Unikalne parki:',
    'pota.date': 'Data',
    'pota.role': 'Rola',
    'pota.bands': 'Pasma',
    'pota.modes': 'Mody',
    'pota.activation': '🏕️ Aktywacja',
    'pota.hunt': '🎯 Hunt',
    'pota.noQsosWithField': 'Brak QSO z wypelnionym polem POTA w Twoim logu. Wypelnij pole "POTA ref" w formularzu loggera (sekcja "Pola zawodow/dyplomow") podczas aktywacji, albo kliknij "📋 Log" na spocie aktywatora w zakladce "Aktywne spoty".',
    'planner.title': '🗓️ Planer aktywacji POTA/SOTA',
    'planner.desc': 'Wybierz lokalizację (ręcznie albo po referencji parku POTA) i date -- zobaczysz godzinowy rozklad dnia/nocy/grayline z sugerowanymi pasmami, plus prognoze aktywnosci slonecznej (SFI/A/K) z NOAA, jeśli data miesci się w 27-dniowym oknie.',
    'planner.refLabel': 'Referencja POTA',
    'planner.latLabel': 'Szerokość',
    'planner.lonLabel': 'Długość',
    'planner.dateLabel': 'Data',
    'planner.runBtn': 'Policz',
    'planner.errNoRef': 'Wpisz referencję parku',
    'planner.errLookup': 'Nie udało się znaleźć parku o tej referencji',
    'planner.parkFound': 'Znaleziono:',
    'planner.errNoCoords': 'Wymagane współrzędne (wpisz ręcznie albo znajdź park po referencji)',
    'planner.errLoad': 'Nie udało się policzyć planu aktywacji',
    'planner.forecastFor': 'Prognoza na',
    'planner.noForecast': 'Wybrana data jest poza 27-dniowym oknem prognozy NOAA -- poniżej tylko rozkład dnia/nocy (astronomiczny, zawsze dokładny).',
    'planner.colHourUtc': 'Godzina UTC',
    'planner.colPhase': 'Faza',
    'planner.colElevation': 'Elewacja Słońca',
    'planner.colBands': 'Sugerowane pasma',
    'planner.phase.day': 'Dzień',
    'planner.phase.night': 'Noc',
    'planner.phase.grayline': 'Grayline',
    'planner.currentConditionsNote': 'Dla porównania, warunki TERAZ:',
    'planner.currentConditionsHint': '(nie prognoza na wybraną datę -- to tylko punkt odniesienia).',
    'aprs.title': '📍 APRS -- ostatnia pozycja',
    'aprs.desc': 'Wyszukaj ostatnią zgłaszaną pozycję znaku przez APRS-IS. Wyłącznie odczyt -- ta funkcja nie wysyła żadnych pozycji ani wiadomości.',
    'aprs.placeholder': 'Znak (np. SQ7SE-9)',
    'aprs.searchBtn': 'Szukaj',
    'aprs.errLoad': 'Nie udało się pobrać pozycji z APRS-IS',
    'aprs.foundLabel': 'Ostatnia pozycja:',

    'psk.lastHour': 'Ostatnia godzina · pskreporter.info',
    'psk.errConnection': 'Błąd połączenia z PSK Reporter',
    'psk.noReportsInfo': 'Brak raportów w ostatniej godzinie. Działa tylko dla modów cyfrowych (FT8/FT4/JS8 itp.) dekodowanych przez sieciowych odbiornikow (np. użytkowników WSJT-X z PSK Reporter Spotting).',
    'psk.receivedBy': 'Odebrane przez',
    'psk.locator': 'Lokator',

    'sat.errPasses': 'Błąd pobierania przejść satelitów',
    'sat.now': 'TERAZ!',
    'sat.in': 'za',
    'sat.subtitle': 'SGP4 + dane orbitalne Celestrak · Twoja lokalizacja z profilu',
    'sat.refresh': '↻ Odśwież',
    'sat.noPasses': 'Brak nadchodzących przejść w najbliższych 48h (albo żaden satelita z listy nie jest aktualnie aktywny w katalogu Celestrak)',
    'sat.qualityHigh': 'wysoki',
    'sat.qualityMedium': 'średni',
    'sat.qualityLow': 'niski',
    'sat.qualityTitle': 'Elewacja szczytu: wysoki ≥30°, średni ≥10°, niski <10° (radiowo wciąż użyteczny)',
    'sat.peak': 'Szczyt',
    'sat.duration': 'Czas trwania',
    'sat.morePasses': 'kolejnych przejść w najbliższych 48h',

    'websdr.integration': 'Integracja z OpenWebRX (WebSocket, w iframe)',
    'websdr.mode': 'Mode',
    'websdr.fromRadio': 'Z radia',
    'websdr.fromRadioTitle': 'Wymaga uruchomionego agenta CAT',
    'websdr.manageDesc': 'Lista poniżej to przykładowe, publicznie dostępne odbiorniki OpenWebRX -- mogą okazjonalnie być offline (typowe dla hobbystycznych odbiorników). Dodaj własne, znalezione np. na',
    'websdr.addBtn': '+ Dodaj',
    'websdr.httpWarningTitle': 'http:// -- w niektórych przeglądarkach może się nie wczytać w tym widoku (mixed content), wtedy użyj przycisku \'otworz w nowej karcie\'',
    'websdr.tunedTo': 'Nastawiono na',
    'websdr.close': '✕ Zamknij',
    'websdr.httpWarning': '⚠️ Ten odbiornik używa http:// -- jeśli poniżej widzisz pustą ramkę, kliknij "↗ Otwórz w nowej karcie" (zawsze działa).',
    'websdr.mixedContentTitle': 'Pełna nawigacja w nowej karcie nigdy nie podlega blokadzie mixed content -- działa zawsze, niezaleznie od http/https',

    'svx.groupsBy': 'Lista grup zdefiniowana przez administratora',
    'svx.errGroups': 'Błąd pobierania listy grup',
    'svx.noGroups': 'Brak skonfigurowanych grup -- administrator może je dodać w Panel Admin → Ustawienia.',
    'svx.bgPlayback': '🔊 Odtwarzanie kontynuuje się w tle (widget w lewym dolnym rogu) nawet po przejściu do innej zakładki.',
    'svx.streamErr': 'Nie udało się wczytać strumienia',
    'svx.streamErrHint': '-- sprawdź czy serwer streamingowy działa',
    'svx.logQso': 'Zaloguj QSO',
    // 2FA -- pelne
    '2fa.recommended': 'Twoje konto ma podwyższone uprawnienia. Włączenie 2FA jest mocno zalecane — konta administratorów i moderatorów są głównym celem ataków.',
    '2fa.isEnabled': '✅ 2FA jest włączone',
    '2fa.codeRequired': 'Przy logowaniu wymagany jest kod z aplikacji. Pozostało kodów zapasowych:',
    '2fa.disableConfirm': 'Wyłączyć 2FA?',
    '2fa.disableDesc': 'Konto straci dodatkową ochronę. Potwierdź hasłem.',
    '2fa.password': 'Twoje hasło',
    '2fa.intro': 'Drugi składnik (kod z aplikacji) chroni konto nawet gdy ktoś pozna Twoje hasło. Działa z Google Authenticator, Aegis, 1Password i innymi.',
    '2fa.step1': '1. Zeskanuj kod w aplikacji uwierzytelniającej',
    '2fa.step2': '2. Wpisz kod z aplikacji, aby potwierdzić',
    '2fa.cantScan': 'Nie możesz zeskanować? Wpisz ręcznie:',
    '2fa.confirmEnable': 'Potwierdź i włącz',
    '2fa.saveNow': '🔑 Kody zapasowe — zapisz je TERAZ',
    '2fa.backupDesc': 'To Twój jedyny ratunek, gdy stracisz telefon. Każdy działa raz. Nie zobaczysz ich ponownie — zapisz w bezpiecznym miejscu.',
    '2fa.copy': 'Kopiuj',
    '2fa.savedClose': 'Zapisałem — zamknij',
    // Widoki Info / Na zywo -- pelne
    'news.title': 'Wiadomości krótkofalarskie',
    'news.desc': 'Najnowsze wiadomości ze świata krótkofalarstwa, zebrane z kilku źródeł w jednym miejscu.',
    'news.empty': 'Brak wiadomości do wyświetlenia (źródła mogą być chwilowo niedostępne).',
    'contests.title': 'Kalendarz zawodów',
    'contests.desc': 'Trwające i nadchodzące zawody krótkofalarskie (najbliższe 30 dni).',
    'contests.live': 'Trwają teraz',
    'contests.remind': 'Przypomnij', 'contests.remindSaved': 'Przypomnienie ustawione — dostaniesz powiadomienie push', 'contests.remindBefore': 'Przypominaj przed startem:', 'contests.myReminders': 'Moje przypomnienia',
    'contests.upcoming': 'Nadchodzące',
    'contests.descLink': 'Kliknij nazwę, aby zobaczyć regulamin na stronie źródłowej.',
    'contests.errLoad': 'Nie udało się pobrać kalendarza zawodów',
    'contests.loadingCal': 'Ładowanie kalendarza...',
    'contests.noContests': 'Brak zawodów do wyświetlenia. Źródło może być chwilowo niedostępne z serwera — sprawdź status poniżej.',
    'contests.liveBadge': 'NA ŻYWO',
    'contests.today': 'dziś',
    'contests.tomorrow': 'jutro',
    'contests.inDays': 'za',
    'contests.days': 'dni',
    'dxped.title': 'Ekspedycje DX',
    'dxped.desc': 'Zapowiedziane ekspedycje DX (trwające i nadchodzące, do 90 dni).',
    'dxped.activeNow': 'Aktywne teraz',
    'dxped.descFull': 'Zapowiedziane ekspedycje DX (trwające i nadchodzące, do 90 dni). Dane z kalendarza DXCAL/ADXO. Sprawdź pasma i emisje, żeby zaplanować upolowanie nowego DXCC.',
    'dxped.sourceUnavailable': 'Źródło ekspedycji chwilowo niedostępne z serwera.',
    'dxped.qsl': 'QSL:',
    'dxped.qrv': 'QRV',
    'dxped.errLoad': 'Nie udało się pobrać listy ekspedycji',
    'trash.title': 'Kosz',
    'trash.errLoad': 'Nie udało się pobrać kosza',
    'trash.errGeneric': 'Błąd',
    'trash.restoredMsg': 'Przywrócono',
    'trash.purgedMsg': 'Usunięto trwale',
    'trash.selectedQso': 'zaznaczonych QSO',
    'trash.wholeBin': 'CAŁY kosz',
    'trash.confirmPurgePre': 'Usunąć trwale',
    'trash.confirmPurgePost': '?\n\nTej operacji NIE DA SIĘ cofnąć — łączności znikną na zawsze.',
    'trash.descPre': 'Usunięte łączności czekają tu',
    'trash.descPost': 'zanim znikną na dobre. Nie liczą się do statystyk, dyplomów ani eksportu ADIF — dopiero po przywróceniu wracają do dziennika.',
    'trash.restoreBtn': '♻️ Przywróć',
    'trash.purgeBtn': 'Usuń trwale',
    'trash.deselect': 'Odznacz',
    'trash.emptyPre': 'Kosz jest pusty. Usunięte QSO pojawią się tutaj i będą czekać',
    'trash.emptyPost': 'na ewentualne przywrócenie.',
    'trash.colDeleted': 'Usunięto',
    'trash.colExpiresIn': 'Zniknie za',
    'trash.daysUnit': 'dni',
    'trash.emptyBin': 'Opróżnij cały kosz',
    'mw.title': 'Most Wanted DXCC',
    'mw.desc': 'Ranking najbardziej poszukiwanych encji DXCC wg Club Log.',
    'dxccmap.title': 'Moja mapa DXCC',
    'dxccmap.worked': 'Zrobione kraje',
    'dxccmap.missingMw': 'Najbardziej poszukiwane, których Ci brakuje',
    'dxccmap.errLoad': 'Nie udało się pobrać mapy DXCC',
    'dxccmap.mwListNote': 'Lista na podstawie rankingu Most Wanted — te encje warto szczególnie upolować.',
    'dxccmap.showLess': 'Pokaż mniej',
    'dxccmap.showAll': 'Pokaż wszystkie',
    'dxccmap.unmappedTitle': 'Nierozpoznane nazwy krajów',
    'dxccmap.unmappedNote': 'Te QSO nie zostały policzone do DXCC — sprawdź, czy nazwa kraju jest poprawna.',
    'dxneeded.title': 'Łowca braków (DX)',
    'dxneeded.onlyNeeded': 'Tylko braki',
    'dxneeded.descPre': 'Spoty z DX Clustera, których',
    'dxneeded.prefixWord': 'prefiksu',
    'dxneeded.descPost': 'nie masz jeszcze w logu — potencjalnie warte zawołania. To sygnał po prefiksie WPX, nie ścisła gwarancja nowego DXCC.',
    'dxneeded.errLoad': 'Nie udało się pobrać spotów',
    'dxneeded.all': 'Wszystkie',
    'dxneeded.emptyNeeded': 'Brak nowych prefiksów wśród aktualnych spotów. Wszystko już masz! 🎉 (albo klaster jest cichy)',
    'dxneeded.emptyAll': 'Brak spotów. DX Cluster może się jeszcze łączyć — zajrzyj do zakładki „DX Cluster".',
    'dxneeded.prefix': 'prefiks',
    'dxneeded.logQsoTitle': 'Zaloguj QSO z tą stacją',
    'dxneeded.footer1': 'Masz',
    'dxneeded.footer2': 'prefiksów w logu · odświeżanie co 30s · spoty z tego samego źródła co „DX Cluster"',
    'wwff.title': 'WWFF — Flora & Fauna',
    'activity.title': 'Aktywność',
    'activity.longestStreak': 'Najdłuższa seria (dni)',
    'activity.currentStreak': 'Aktualna seria (dni)',
    'activity.activeDays': 'Dni z łącznościami',
    'activity.avgPerDay': 'Średnio QSO / dzień',
    'activity.bestDay': 'Najlepszy dzień',
    'activity.byYear': 'Łączności wg roku',
    // Logger -- formularz (pelne)
    'logger.callsignReq': 'Znak wywoławczy *',
    'logger.dateTimeUtc': 'Data/Czas UTC',
    'logger.modeReq': 'Emisja *',
    'logger.freqReq': 'Częstotliwość (MHz) *',
    'logger.nameSurname': 'Imię i Nazwisko',
    'logger.gridLoc': 'Lokator',
    'logger.dxcc': 'DXCC',
    'logger.iota': 'IOTA',
    'logger.usState': 'Stan (USA)',
    'logger.cqZone': 'Strefa CQ',
    'logger.qslSent': 'QSL wysłana',
    'logger.qslRecv': 'QSL otrzymana',
    // Auth
    'auth.callsign': 'Znak wywoławczy',
    'auth.email': 'Email',
    'auth.password': 'Hasło',
    'auth.newPassword': 'Nowe hasło',
    'auth.repeatPassword': 'Powtórz nowe hasło',
    'auth.login': 'Zaloguj się',
    'auth.register': 'Zarejestruj się',
    'auth.confirmCode': 'Potwierdź kod',
    'auth.sendResetLink': 'Wyślij link resetujący',
    'auth.totpHint': 'Wpisz kod z aplikacji uwierzytelniającej. Nie masz telefonu? Użyj jednego z kodów zapasowych.',
    // Radio
    'radio.model': 'Model radia',
    'radio.connType': 'Typ połączenia',
    'radio.serialPort': 'Port szeregowy',
    // LiveViews
    'pota.title': 'POTA / SOTA',
    'psk.title': 'PSK Reporter — Gdzie słyszano Twój sygnał',
    'sat.title': 'Satelity amatorskie — nadchodzące przejścia',
    'websdr.title': 'WebSDR — sprawdź czy się słyszysz',
    'svx.title': 'SVXLink — nasłuch grup na żywo',
    'pota.spots': 'Aktywne spoty',
    'pota.myStats': 'Moje statystyki',
    'pota.park': 'Park',
    // Community
    'diplomas.title': 'Akcje Dyplomowe',
    'neighbors.title': 'Wyszukiwarka Sąsiedztwa',
    'shared.title': 'Wspólny Dziennik (Multi-Operator)',
    'diplomas.sync': 'Synchronizuj teraz',
    'diplomas.activeNow': 'Aktywni teraz',
    // Tools
    'weather.title': 'Pogoda',
    'eqsl.title': 'Projekt eQSL',
    'eqsl.accentColor': 'Kolor akcentu',
    'eqsl.textColor': 'Kolor tekstu',
    'eqsl.clubName': 'Nazwa klubu (opcjonalnie)',
    'eqsl.slogan': 'Slogan / podpis',
    // Pozostale widoki
    'contest.title': 'Tryb zawodów',
    'watchlist.title': 'DX Watchlist — Alerty Telegram + Discord',
    'logbook.header': 'Dziennik',
    'qsomap.title': 'Mapa Łączności',
    'cluster.title': 'DX Cluster',
    // Komunikaty notify -- najczestsze
    'notify.qsoSaved': 'QSO zapisane w logu!',
    'notify.qsoUpdated': 'QSO zaktualizowane',
    'notify.qsoDeleted': 'QSO usunięte',
    'notify.saveError': 'Błąd zapisu',
    'notify.loadError': 'Błąd pobierania danych',
    'notify.badFreq': 'Wpisz poprawną częstotliwość',
    'notify.radioSaved': 'Konfiguracja radia zapisana',
    'notify.qsyError': 'Błąd wysyłki komendy QSY',
    'notify.exported': 'Wyeksportowano',
    'notify.imported': 'Zaimportowano',
    'notify.copied': 'Skopiowano',
    // Admin -- pelne
    'admin.newAnnouncement': 'Nowe ogłoszenie',
    'admin.title': 'Tytuł',
    'admin.body': 'Treść',
    'admin.bodyPlaceholder': 'Szczegóły komunikatu...',
    'admin.level': 'Poziom',
    'admin.levelInfo': 'ℹ️ Informacja',
    'admin.levelWarning': '⚠️ Ostrzeżenie',
    'admin.levelCritical': '🚨 Krytyczne (nie da się schować)',
    'admin.expires': 'Wygasa (opcjonalnie)',
    'admin.publish': '📢 Opublikuj',
    'admin.published': 'Opublikowane',
    'admin.noAnnouncements': 'Brak ogłoszeń',
    'admin.deleted': '(usunięty)',
    'admin.expired': '(wygasło)',
    'admin.actionDeleteUser': '🗑️ Usunięcie konta',
    'admin.actionUpdateUser': '✏️ Zmiana uprawnień/statusu',
    'admin.actionResetPassword': '🔑 Reset hasła',
    'admin.actionImpersonate': '🎭 Logowanie jako użytkownik',
    'admin.actionUpdateSettings': '⚙️ Zmiana ustawień systemowych',
    'admin.actionUpdateQso': '✏️ Edycja cudzego QSO',
    'admin.actionDeleteQso': '🗑️ Usunięcie cudzego QSO',
    'admin.errLoadAnnouncements': 'Nie udało się pobrać ogłoszeń',
    'admin.titleBodyRequired': 'Tytuł i treść są wymagane',
    'admin.titlePlaceholder': 'np. Planowany restart serwera',
    'admin.announcementPublished': 'Ogłoszenie opublikowane',
    'admin.errPublish': 'Błąd publikacji',
    'admin.errGeneric': 'Błąd',
    'admin.confirmDeleteAnnouncement': 'Trwale usunąć ogłoszenie',
    'admin.itemDeleted': 'Usunięto',
    'admin.announcementNote': 'Ogłoszenie zobaczą wszyscy zalogowani użytkownicy w banerze na górze aplikacji. Poziom „krytyczne" nie może zostać schowany przez użytkownika. Po dacie wygaśnięcia ogłoszenie samo znika.',
    'admin.expiresAt': 'wygasa',
    'admin.disabled': '(wyłączone)',
    'admin.deletePermanently': 'Usuń trwale',
    'admin.enable': '✅ Włącz',
    'admin.disable': '⛔ Wyłącz',
    'admin.details': 'Szczegóły',
    'admin.whoAffected': 'Kogo dotyczyło',
    'admin.testFeatures': 'Funkcje w fazie testów',
    'admin.noTestFeatures': 'Brak funkcji w fazie testów.',
    'admin.repeaterDb': '📡 Baza przemienników',
    'admin.svxGroups': '🎙️ Grupy SVXLink',
    'admin.addGroup': '+ Dodaj grupę',
    'admin.clearLog': 'Wyczyść log',
    'admin.next': 'Następna →',
    'admin.retry': 'Spróbuj ponownie',
    'admin.noBackup': 'Brak danych -- backup jeszcze się nie wykonał',
    'admin.termsContent': 'Treść regulaminu (markdown)',
    'admin.adminName': 'Imię i nazwisko / znak administratora',
    'admin.threshold': 'Próg (liczba nieudanych prób w 10 min):',
    'admin.sentByMail': 'Wysyłane mailem do',
    'admin.errFeatureFlags404': 'Endpoint nie istnieje na serwerze (404). Zbuduj i wdróż backend: sudo docker compose build --no-cache backend && sudo docker compose up -d',
    'admin.errFeatureFlagsLoad': 'Błąd ładowania funkcji testowych',
    'admin.featureEnabledAll': 'włączona',
    'admin.featureDisabledAll': 'wyłączona',
    'admin.featureToggled': 'Funkcja',
    'admin.featureToggledSuffix': 'dla wszystkich',
    'admin.errToggleFlag': 'Błąd zmiany flagi',
    'admin.logCleared': 'Log wyczyszczony',
    'admin.repeatersImported': 'Zaimportowano',
    'admin.repeatersUnit': 'przemienników',
    'admin.errImport': 'Błąd importu',
    'admin.saved': 'Zapisano',
    'admin.altCallsignsPromptTitle': 'Znaki okolicznościowe dla',
    'admin.altCallsignsPromptBody': 'Oddziel przecinkami, np: SN0HQ, HF100PL\nPozostaw puste, aby odebrać wszystkie.\n\nUwaga: QSO już zalogowane pod odebranym znakiem POZOSTANĄ w logu.',
    'admin.altCallsignsGranted': 'nadano znaki',
    'admin.altCallsignsRevoked': 'odebrano znaki okolicznościowe',
    'admin.errGrantCallsigns': 'Błąd nadawania znaków',
    'admin.roleUser': 'Użytkownik',
    'admin.roleModerator': 'Moderator',
    'admin.roleAdmin': 'Administrator',
    'admin.confirmGrantRole': 'Nadać użytkownikowi',
    'admin.roleColon': 'rolę:',
    'admin.roleAdminDetail': 'Administrator ma PEŁNY dostęp: usuwanie kont, ustawienia systemu, backupy, podszywanie się.',
    'admin.roleModeratorDetail': 'Moderator może przeglądać panel i zawieszać konta, ale NIE może nadawać uprawnień ani usuwać kont.',
    'admin.roleChanged': 'Rola',
    'admin.errChangeRole': 'Błąd zmiany roli',
    'admin.confirmDeleteAccount': 'Usunąć konto',
    'admin.confirmDeleteAccountSuffix': 'wraz z całym logiem? Tej operacji nie da się odwrócić.',
    'admin.accountDeletedSuffix': 'usunięte',
    'admin.confirmImpersonate': 'Zalogować się jako',
    'admin.confirmImpersonateSuffix': '? Twoja własna sesja zostanie zachowana -- będziesz mógł łatwo wrócić.',
    'admin.errImpersonate': 'Błąd przełączenia konta',
    'admin.loadingPanel': '⏳ Ładowanie panelu admina...',
    'admin.panelTitle': 'Panel Admina',
    'admin.systemStatusHeading': '🩺 Stan systemu',
    'admin.testFeaturesTab': 'Funkcje testowe',
    'admin.systemStatusTab': 'Stan systemu',
    'admin.moderatorModeTitle': 'Tryb moderatora.',
    'admin.moderatorModeDesc1': 'Możesz przeglądać statystyki, listę użytkowników i log aktywności oraz',
    'admin.moderatorModeDesc2': 'zawieszać/odwieszać zwykłe konta',
    'admin.moderatorModeDesc3': 'Nadawanie uprawnień, usuwanie kont, ustawienia systemu i backupy są zastrzeżone dla administratora.',
    'admin.statUsers': 'Użytkownicy',
    'admin.statQsos': 'Łączności (wszyscy)',
    'admin.statVerified': 'Zweryfikowani email',
    'admin.statPublicProfiles': 'Publiczne profile',
    'admin.statSuspended': 'Zawieszone konta',
    'admin.statSharedLogs': 'Wspólne dzienniki',
    'admin.smtpLabel': 'SMTP',
    'admin.smtpConfigured': '✅ Skonfigurowane',
    'admin.smtpNotConfigured': '⚠️ Nieskonfigurowane',
    'admin.telegramLabel': 'Telegram Bot',
    'admin.telegramConfigured': '✅ Skonfigurowany',
    'admin.telegramNotConfigured': '⚠️ Nieskonfigurowany',
    'admin.clusterCacheLabel': 'DX Cluster cache',
    'admin.spotsUnit': 'spotów',
    'admin.secondsAgo': 's temu',
    'admin.lastDiplomaSync': 'Ostatnia synchr. dyplomów',
    'admin.neverYet': 'jeszcze nie',
    'admin.recentRegistrations': 'Ostatnie rejestracje',
    'admin.colCallsign': 'Znak',
    'admin.colEmail': 'Email',
    'admin.colDate': 'Data',
    'admin.colEmailVerified': 'Email zweryfikowany',
    'admin.colQso': 'QSO',
    'admin.colLastLogin': 'Ostatnie logowanie',
    'admin.colVerified': 'Zweryfikowany',
    'admin.never': 'nigdy',
    'admin.today': 'dzisiaj',
    'admin.yesterday': 'wczoraj',
    'admin.daysAgo': 'dni temu',
    'admin.cannotChangeOwnRole': 'Nie możesz zmienić własnej roli admina',
    'admin.changeRoleTitle': 'Zmień rolę',
    'admin.resetPasswordBtn': 'Reset hasła',
    'admin.editAccountBtn': 'Dane konta',
    'admin.editAccountTitle': 'Popraw email/znak/lokalizację domową',
    'admin.qsoManageBtn': 'QSO',
    'admin.qsoManageTitle': 'Przegląd/edycja QSO tego użytkownika',
    'admin.altCallsignsBtn': 'Znaki',
    'admin.altCallsignsTitle': 'Nadaj/odbierz znaki okolicznościowe (SN0HQ, HF100PL...)',
    'admin.impersonateBtn': '🎭 Zaloguj jako',
    'admin.impersonateTitle': 'Zaloguj się jako ten użytkownik (np. stacja okolicznościowa)',
    'admin.ffDescPre': 'Funkcje poniżej są widoczne dla',
    'admin.ffDescAdminsAlways': 'administratorów zawsze',
    'admin.ffDescMid': '(możesz je testować od razu). Przełącznik decyduje, czy funkcja jest widoczna również dla',
    'admin.ffDescPost': 'Włącz dopiero, gdy funkcja jest gotowa.',
    'admin.ffDescYoutuber': 'Użytkownicy z grupy 🎥 Youtuber (patrz kolumna w tabeli poniżej) też widzą wszystkie funkcje testowe od razu, tak jak admini -- niezależnie od swojej roli. To dodatkowa, osobna grupa (nie zastępuje ról user/moderator/admin), przydatna żeby ktoś mógł pokazać nowość w materiale wideo zanim trafi do wszystkich.',
    'admin.colYoutuber': '🎥 Youtuber',
    'admin.youtuberColTitle': 'Dodatkowa grupa z wczesnym dostępem do funkcji testowych (niezależnie od roli)',
    'admin.youtuberCheckboxTitle': 'Youtuber -- wczesny dostęp do funkcji testowych, tak jak admin (bez innych uprawnień)',
    'admin.featureVisibleAll': '● widoczna dla wszystkich',
    'admin.featureAdminOnly': '○ tylko dla adminów',
    'admin.idLabel': 'id:',
    'admin.backupsDescA': 'Backupy wykonuje automatycznie osobny serwis w tle (cron, według harmonogramu',
    'admin.backupsDescB': 'z',
    'admin.backupsDescC': ', domyślnie codziennie o 3:00) -- ta lista jest czysto informacyjna. Pliki trzymane są',
    'admin.backupsDescD': 'dni (domyślnie 14), starsze są automatycznie usuwane.',
    'admin.refreshList': '↻ Odśwież listę',
    'admin.colFile': 'Plik',
    'admin.colSize': 'Rozmiar',
    'admin.colCreated': 'Utworzono',
    'admin.restoreBtn': '♻️ Przywróć',
    'admin.restoreTitle': 'Przywróć bazę z tego pliku -- nadpisuje bieżące dane',
    'admin.noBackupsYet': 'Brak backupów (pierwszy zostanie wykonany automatycznie wkrótce po starcie serwisu "backup")',
    'admin.manualRestoreDesc': 'Przywracanie ręcznie z linii komend (alternatywa dla przycisku "♻️ Przywróć" wyżej, gdyby np. backend był akurat niedostępny):',
    'admin.repeaterDbDescA': 'Dane przemienników (zakładka "📡 Przemienniki" w Loggerze) są przechowywane lokalnie w bazie, NIE odpytywane na żywo z przemienniki.eu. Aby zaktualizować, pobierz świeży eksport JSON z',
    'admin.repeaterDbDescB': 'i wgraj go poniżej (zastąpi całą obecną bazę).',
    'admin.repeatersInDb': 'W bazie:',
    'admin.lastImport': 'ostatni import:',
    'admin.importingRepeaters': '⏳ Importowanie...',
    'admin.uploadJsonExport': 'Wgraj eksport JSON',
    'admin.loadingGeneric': '⏳ Ładowanie...',
    'admin.statusPageDesc': 'Stan instalacji w jednym miejscu -- zamiast odkrywać problem dopiero gdy coś nie zadziała u użytkownika. Status zewnętrznych serwisów sprawdzany na żywo (przy każdym otwarciu tej zakładki).',
    'admin.backupDbTitle': '💾 Backup bazy danych',
    'admin.statusOk': '✓ OK',
    'admin.statusError': '✗ BŁĄD',
    'admin.smtpEmailTitle': '✉️ SMTP (email)',
    'admin.notConfigured': 'Nie skonfigurowane',
    'admin.smtpWorks': '✓ Działa',
    'admin.smtpLastSendError': '✗ Błąd przy ostatniej wysyłce',
    'admin.noData': 'Brak danych',
    'admin.securityLabel': 'Zabezpieczenie:',
    'admin.hamqslTitle': '🌍 hamqsl.com (propagacja)',
    'admin.available': '✓ Dostępny',
    'admin.unavailable': '✗ Niedostępny',
    'admin.qrzTitle': '📇 QRZ.com',
    'admin.dbTitle': '📊 Baza danych',
    'admin.dbActiveUsers': 'aktywnych /',
    'admin.dbTotalUsers': 'kont razem',
    'admin.activityLogDesc': 'Wrażliwe akcje administracyjne -- usunięcie konta, reset hasła komuś, logowanie się jako inny użytkownik, zmiana uprawnień/zawieszenie konta, zmiana ustawień systemowych. Nie pełny audyt (nie loguje przeglądania danych), tylko podstawowa odpowiedzialność.',
    'admin.noActionsLogged': 'Brak zarejestrowanych akcji',
    'admin.colWhen': 'Kiedy',
    'admin.colAdmin': 'Admin',
    'admin.colAction': 'Akcja',
    'admin.prevPage': '← Poprzednia',
    'admin.pageLabel': 'Strona',
    'admin.debugDescA': 'Logi diagnostyczne z zakładki WebSDR (każdego użytkownika) -- włącz/wyłącz zbieranie w zakładce "Ustawienia". Jedna z możliwych (ale NIE gwarantowanych) przyczyn "nie zawsze się ładuje": odbiornik po',
    'admin.debugDescB': 'embedowany na stronie po',
    'admin.debugDescC': 'może zostać zablokowany przez przeglądarkę bez żadnego komunikatu błędu ("mixed content") -- ale zachowanie różni się między przeglądarkami. Wpis',
    'admin.debugDescD': 'w kolumnie "Szczegóły" wspomina o http:// jeśli to dotyczyło tego odbiornika.',
    'admin.colTime': 'Czas',
    'admin.colEvent': 'Zdarzenie',
    'admin.colReceiver': 'Odbiornik',
    'admin.colFreqMode': 'Freq/Mode',
    'admin.noDebugEntries': 'Brak wpisów',
    'admin.debugCollectionOff': '-- albo zbieranie logów jest wyłączone w Ustawieniach',
    'common.refreshBtn': '↻ Odśwież',
    // App -- pozostale
    'bulk.changeBand': 'Zmień pasmo na...',
    'bulk.changeMode': 'Zmień emisję na...',
    'bulk.applyBand': 'Zastosuj pasmo',
    'bulk.applyMode': 'Zastosuj emisję',
    'bulk.deleteSelected': 'Usuń zaznaczone',
    'bulk.qslToSend': '📇 QSL do wysłania',
    'bulk.applyStation': 'Zastosuj znak',
    'common.loadingDots': '⏳ Ładowanie...',
    'common.refreshNow': '↻ Odśwież teraz',
    'common.back': '← Wróć',
    'common.qsos': 'Łączności',
    'common.details': 'Szczegóły',
    'common.later': 'Później',
    'common.available': 'Dostępne:',
    'contest.exchangeSent': 'Wymiana wysłana (np. 599 001)',
    'contest.name': 'Nazwa zawodów',
    'contest.backToLogger': '↩ Wróć do normalnego loggera',
    'cluster.connecting': '⏳ Łączenie ze strumieniem klastra DX...',
    'eqsl.sendNow': '✓ Wyślij teraz',
    'eqsl.send': '📧 Wyślij eQSL',
    'eqsl.toSend': '⏳ Do wysłania',
    'eqsl.sent': '📤 Wysłane',
    'newVersion': '🔄 Dostępna nowa wersja HamLoggera — odśwież, żeby ją wczytać.',
    'lang.label': 'Język / Language',
    // Kalkulator anten
    'ant.plotConditions': 'Warunki działki',
    'ant.maxHeight': 'Max wysokość (m)',
    'ant.maxHorizontal': 'Max długość pozioma (m)',
    'ant.canBuryRadials': 'Mogę zakopać radiale',
    'ant.setConditions': 'Ustaw warunki działki i kliknij „Oblicz anteny”.',
    'ant.noResults': 'Brak wyników dla wybranych pasm.',
    'ant.showViz': 'Pokaż wizualizację',
    'ant.selectForViz': 'Wybierz antenę w zakładce „Wyniki”, aby zobaczyć wizualizację.',
    'ant.freqMhz': 'Częstotliwość (MHz)',
    'ant.lengthM': 'Długość (m)',
    'ant.wireDiameter': 'Średnica drutu (mm)',
    'ant.electricalLength': 'Długość elektryczna',
    'ant.peakVoltage': 'Napięcie szczytowe',
    'ant.efficiency': 'Sprawność',
    'ant.totalLoss': 'Strata całkowita',
    'ant.searchAddress': 'Szukaj adresu / miejscowości...',
    'ant.clickMapTerrain': 'Kliknij na mapie, aby sprawdzić wysokość terenu w danym punkcie.',

    'pathcalc.title': 'Kalkulator trasy DX',
    'pathcalc.desc': 'Podaj lokator stacji, z którą chcesz nawiązać łączność -- policzę dystans, azymut (trasa krótka i długa) z Twojego QTH oraz sprawdzę porę dnia po obu stronach. Przydatne przed wywołaniem CQ na niskich pasmach: grayline po którejkolwiek stronie zwykle oznacza lepsze warunki DX.',
    'pathcalc.targetGrid': 'Lokator celu (np. FN20, JO91)',
    'pathcalc.targetPlaceholder': 'np. KN18',
    'pathcalc.calculate': 'Oblicz',
    'pathcalc.errEmpty': 'Wpisz lokator (np. FN20 dla wschodnich USA).',
    'pathcalc.errInvalidGrid': 'Nieprawidłowy lokator Maidenhead.',
    'pathcalc.errUnreadable': 'Nie udało się odczytać lokatora.',
    'pathcalc.distance': 'Dystans',
    'pathcalc.miles': 'mil',
    'pathcalc.bearingShort': 'Azymut (short path)',
    'pathcalc.bearingLong': 'Azymut (long path)',
    'pathcalc.yourQth': '🏠 Twoje QTH',
    'pathcalc.day': 'Dzień',
    'pathcalc.night': 'Noc',
    'pathcalc.grayline': 'Grayline (świt/zmierzch)',
    'pathcalc.greylineTip': '💡 Przynajmniej jeden koniec trasy jest w strefie grayline/nocy -- dobry moment na próbę DX na 160/80/40m.',

    'qsorate.title': 'Tempo QSO',
    'qsorate.hours12': '12 godzin',
    'qsorate.hours24': '24 godziny',
    'qsorate.hours48': '48 godzin',
    'qsorate.hours72': '72 godziny',
    'qsorate.desc': 'Liczba łączności na godzinę z Twojego logu -- odświeża się automatycznie co minutę. Przydatne w zawodach lub podczas aktywacji, żeby na bieżąco widzieć czy tempo rośnie.',
    'qsorate.last60min': 'QSO (ostatnie 60 min)',
    'qsorate.total': 'Razem',
    'qsorate.bestHour': 'Najlepsza godzina',
    'qsorate.now': 'teraz',
    'qsorate.errLoad': 'Nie udało się pobrać tempa QSO',

    'dashboard.title': 'Pulpit',
    'dashboard.welcome': 'Witaj',
    'dashboard.quickOverview': 'szybki przegląd Twojego logu i eteru.',
    'dashboard.totalQsos': 'Łączności ogółem',
    'dashboard.uniqueCallsigns': 'Unikalne znaki',
    'dashboard.countriesDxcc': 'Kraje (DXCC)',
    'dashboard.newQso': '📻 Nowe QSO',
    'dashboard.recentQsos': 'Ostatnie łączności',
    'dashboard.noQsos': 'Brak łączności w logu -- zacznij od pierwszego QSO.',
    'dashboard.dateTime': 'Data/Czas',

    'roster.title': 'Live Roster',
    'roster.connected': '● połączono',
    'roster.connecting': '○ łączenie...',
    'roster.desc': 'Wszystkie stacje dekodowane przez WSJT-X na bieżąco (nie tylko zalogowane QSO) -- odświeża się samo. Wymaga zaktualizowanego agenta (pobierz ponownie z widżetu Radio, jeśli lista długo zostaje pusta mimo działającego WSJT-X).',
    'roster.filterPlaceholder': '🔍 Filtruj po znaku...',
    'roster.onlyNew': 'Tylko nowe (jeszcze niepracowane)',
    'roster.stationCount': 'stacji',
    'roster.noDataAtAll': 'Brak danych -- upewnij się, że agent WSJT-X działa i masz najnowszą wersję (widżet Radio -> pobierz ponownie).',
    'roster.noDataFiltered': 'Brak stacji pasujących do filtra.',
    'roster.snr': 'SNR',
    'roster.grid': 'Lokator',
    'roster.isCq': 'CQ?',
    'roster.lastHeard': 'Ostatnio',
    'roster.status': 'Status',
    'roster.alreadyWorked': 'już pracowany',
    'roster.new': '✨ nowy',
    'roster.loadToLogger': 'Do loggera',
    'roster.errLoad': 'Nie udało się pobrać rostera',
    'roster.secondsAgo': 's temu',
    'roster.minutesAgo': 'min temu',

    'grayline.title': 'Mapa grayline (terminator)',
    'grayline.errLoad': 'Nie udało się pobrać danych grayline',
    'grayline.desc': 'Linia terminatora (świt/zmierzch) to strefa wyjątkowej propagacji DX na niskich pasmach (160/80/40m). Stacje leżące blisko tej linii mają teraz najlepsze szanse na łączność grayline. Mapa odświeża się automatycznie co 5 minut.',
    'grayline.subsolarTooltip': '☀️ Punkt podsłoneczny (Słońce w zenicie)',
    'grayline.subsolarPoint': '☀️ Punkt podsłoneczny:',
    'grayline.sunDeclination': 'Deklinacja Słońca:',
    'grayline.serverCalc': 'Obliczenia serwerowe',

    'onthisday.label': 'Tego dnia',
    'onthisday.qsoUnit': 'QSO',
    'onthisday.inPreposition': 'w',
    'onthisday.year': 'roku',
    'onthisday.years': 'latach',
    'onthisday.yearAgo': 'Rok temu',
    'onthisday.yearsAgoSuffix': 'lata temu',
    'onthisday.andMorePrefix': '…i',
    'onthisday.andMoreSuffix': 'więcej',

    'maps.graylineOn': 'WŁ',
    'maps.graylineOff': 'WYŁ',
    'maps.yourPosition': 'Twoja pozycja',
    'maps.qsoInArea': 'QSO w tej okolicy',
    'maps.andMorePrefix': '… i',
    'maps.andMoreSuffix': 'więcej',
    'maps.locatorGridTitle': 'Lokalizacja & Siatka Lokatorów',
    'maps.you': 'Ty',
    'maps.lookupHint': 'Wpisz znak i wykonaj lookup QRZ (lub podaj lokator ręcznie), aby zobaczyć pozycję rozmówcy i odległość',

    'prop.sfiExcellent': 'Doskonałe — wyższe pasma (10/12/15m) otwarte',
    'prop.sfiGood': 'Dobre — wyższe pasma aktywne',
    'prop.sfiModerate': 'Umiarkowane — głównie średnie pasma',
    'prop.sfiWeak': 'Słabe — niższe pasma (40/80m)',
    'prop.sfiVeryWeak': 'Bardzo słabe — trudne warunki HF',
    'prop.kQuiet': 'Spokojnie — bardzo dobre warunki',
    'prop.kUnsettled': 'Nieustabilizowane — warunki OK',
    'prop.kActive': 'Aktywne — możliwe zakłócenia',
    'prop.kStorm': 'Burza geomagnetyczna — pogorszenie HF',
    'prop.kSevereStorm': 'Silna burza — HF mocno zaburzone',
    'prop.xrayExtreme': 'Ekstremalny rozbłysk klasy X',
    'prop.xrayStrong': 'Silny rozbłysk klasy M',
    'prop.xrayModerate': 'Umiarkowany rozbłysk klasy C',
    'prop.xrayQuiet': 'Spokojnie (tło A/B)',
    'prop.errSource': 'Źródło propagacji chwilowo niedostępne (hamqsl.com)',
    'prop.errLoad': 'Nie udało się pobrać danych propagacyjnych',
    'prop.title': 'Propagacja HF/VHF — pogoda kosmiczna',
    'prop.updated': 'Aktualizacja:',
    'prop.source': '· źródło: hamqsl.com (N0NBH)',
    'prop.alertXray': 'możliwe zaniki HF (blackout) po dziennej stronie Ziemi',
    'prop.alertAuroraPrefix': 'Wysoka aktywność zorzy (poziom',
    'prop.alertAuroraSuffix': ') — pogorszenie HF na wysokich szerokościach, możliwa propagacja aurorowa na VHF',
    'prop.sfiLabel': 'SFI (Solar Flux)',
    'prop.aIndex': 'A-index',
    'prop.aIndexHint': 'Aktywność geomag. (dobowa)',
    'prop.solarWindHint': 'Prędkość plazmy',
    'prop.kIndex': 'K-index',
    'prop.aurora': 'Zorza (Aurora)',
    'prop.auroraActiveHint': 'Aktywna — wpływ na propagację',
    'prop.quiet': 'Spokojnie',
    'prop.bzField': 'Bz (pole mag.)',
    'prop.bzSouthHint': 'Skierowane na południe — może wzmagać burze',
    'prop.bzCalmHint': 'Względnie spokojne',
    'prop.geomagField': 'Pole geomagnetyczne',
    'prop.signalNoise': 'Szum pasma (S)',
    'prop.signalNoiseHint': 'Poziom szumu tła',
    'prop.mufHint': 'Max częstotliwość użyteczna',
    'prop.fof2Hint': 'Częstotliwość krytyczna F2',
    'prop.hfConditions': 'Warunki na pasmach HF',
    'prop.band': 'Pasmo',
    'prop.night': 'Noc',
    'prop.vhfConditions': 'Warunki VHF',
    'prop.heliumLine': 'Linia helu 304Å:',
    'prop.banners': 'Grafiki propagacyjne (hamqsl.com)',
    'prop.bannerSolar': 'Warunki słoneczne i pasma',
    'prop.bannerMuf': 'MUF i foF2',
    'prop.bannerVhf': 'Warunki VHF',
    'prop.bannerNote': 'Grafiki generowane na żywo przez hamqsl.com (N0NBH). Jeśli się nie ładują, serwis może być chwilowo niedostępny.',
    'prop.sunAlt': 'Słońce SDO AIA 193',
    'prop.sunNote': 'Solar Dynamics Observatory (NASA), kanał AIA 193Å — pokazuje koronę słoneczną i obszary aktywne. Jaśniejsze rejony to źródła rozbłysków.',

    'weather.errLoad': 'Błąd pobierania pogody',
    'weather.source': 'Pogoda: Open-Meteo · Ostrzeżenia: IMGW-PIB · lokalizacja z profilu',
    'weather.refresh': '↻ Odśwież',
    'weather.imgwOfficial': 'Oficjalne ostrzeżenie IMGW',
    'weather.forecastWarning': 'Ostrzeżenie (prognoza)',
    'weather.degree': 'Stopień',
    'weather.probability': 'prawdopodobieństwo',
    'weather.validFrom': 'obowiązuje',
    'weather.openMeteoForecast': 'Prognoza Open-Meteo (brak aktywnego oficjalnego ostrzeżenia IMGW dla tej lokalizacji/regionu)',
    'weather.stormAdvice': 'Rozważ odłączenie anteny od radia na czas burzy -- wyładowanie atmosferyczne może uszkodzić sprzęt i stanowi realne ryzyko (również pożarowe/elektryczne).',
    'weather.noStorm': '✅ Brak burzy w prognozie na najbliższe 6h',
    'weather.now': 'Teraz',
    'weather.wind': 'Wiatr',
    'weather.windSpeed': 'prędkość',
    'weather.gusts': 'Porywy',
    'weather.maxGust': 'maks. poryw',
    'weather.humidity': 'Wilgotność',
    'weather.precipitation': 'Opad',
    'weather.current': 'bieżący',
    'weather.hourlyForecast': 'Prognoza godzinowa (24h)',
    'weather.noData': 'Brak danych pogodowych',
    'weather.imgwMaps': '🗺️ Mapy IMGW',
    'weather.imgwMapsDesc': 'Mapy IMGW są renderowane dynamicznie (kafelki) -- otwierają się na ich stronie w nowej karcie, zamiast "na sztywno" wbudowanego obrazka, który mógłby przestać działać przy każdej zmianie ich serwisu.',
    'weather.mapWarnings': 'Mapa ostrzeżeń',
    'weather.mapWarningsDesc': 'aktywne alerty meteo/hydro',
    'weather.mapRadar': 'Radar opadów',
    'weather.mapRadarDesc': 'opady na żywo',
    'weather.mapSatellite': 'Zdjęcia satelitarne',
    'weather.mapSatelliteDesc': 'zachmurzenie',
    'weather.mapLightning': 'Wyładowania',
    'weather.mapLightningDesc': 'gęstość/lokalizacja',
    'weather.credit': 'Źródłem pochodzenia danych o ostrzeżeniach jest Instytut Meteorologii i Gospodarki Wodnej – Państwowy Instytut Badawczy (IMGW-PIB). Dane pogodowe: Open-Meteo (open-source).',

    'eqsl.saveTemplate': '✓ Zapisz szablon',
    'eqsl.bgColor': 'Kolor tła',
    'eqsl.bgColorHint': '(używany tylko gdy usuniesz własne tło niżej)',
    'eqsl.clubNamePlaceholder': 'np. Klub SP3PWR',
    'eqsl.borderWidth': 'Grubość ramki',
    'eqsl.showWatermark': 'Pokaż stopkę "Wygenerowano w HamLogger" na karcie',
    'eqsl.langMode': 'Język karty i maila',
    'eqsl.langAuto': 'Automatycznie (wg prefiksu znaku odbiorcy)',
    'eqsl.langAlwaysPl': 'Zawsze polski',
    'eqsl.langAlwaysEn': 'Zawsze angielski',
    'eqsl.langModeDesc': '"Automatycznie" wysyła karty/maile po polsku do znaków SP/SQ/SO, do reszty po angielsku. Wybierz stały język, jeśli zawsze chcesz jednej wersji.',
    'eqsl.dragFieldsDesc': 'Przeciągnij dowolne pole na podglądzie po prawej, żeby zmienić jego miejsce -- przydatne zwłaszcza z własnym tłem (każda karta QSL ma pola w innym miejscu i o innym rozmiarze). Kliknij pole na liście, żeby ustawić jego rozmiar fontu precyzyjnie.',
    'eqsl.fieldX': 'X',
    'eqsl.fieldY': 'Y',
    'eqsl.fieldSize': 'Rozmiar',
    'eqsl.autoSendDesc': 'Ta karta jest automatycznie wysyłana mailem do drugiej stacji (na adres znaleziony w QRZ, jeśli go udostępniła publicznie) -- zaznaczając checkbox "Wyślij eQSL" w formularzu loggera, albo ręcznie z przycisku w Logbooku. Domyślny stan checkboxa ustawiasz w ustawieniach konta (kliknij swój znak w prawym górnym rogu).',
    'eqsl.livePreview': 'Podgląd na żywo',
    'eqsl.dragFields': 'przeciągaj pola',
    'eqsl.previewPl': 'Podgląd wersji polskiej',
    'eqsl.previewEn': 'Podgląd wersji angielskiej',
    'eqsl.previewAlt': 'Podgląd karty eQSL',
    'eqsl.loadingPreview': 'Ładowanie podglądu...',
    'eqsl.customBgTitle': 'Własne tło',
    'eqsl.customBgDesc': 'Jeśli masz już własną, zaprojektowaną kartkę QSL (np. zrobioną w innym programie graficznym), możesz wgrać ją tutaj jako tło -- dane QSO (znak, data, pasmo, RST...) są rysowane NA NIM, w pozycjach które ustawisz powyżej (przeciągając na podglądzie). Bez własnego tła używany jest jednolity kolor z ustawień po lewej.',
    'eqsl.customBgAlt': 'Własne tło eQSL',
    'eqsl.uploading': 'Wgrywanie...',
    'eqsl.changeBg': 'Zmień tło',
    'eqsl.uploadBg': 'Wgraj tło',
    'eqsl.formatsInfo': 'Obsługiwane formaty: JPG, PNG, GIF, WEBP. Max 3MB. Obrazek o innych proporcjach niż karta (900×560) jest automatycznie przycinany do wypełnienia ramki (bez zniekształcenia), tak jak tło w CSS -- jeśli ważne detale są przy samych krawędziach, mogą zostać przycięte.',
    'eqsl.savedNotify': 'Szablon eQSL zapisany!',
    'eqsl.errSaveTemplate': 'Błąd zapisu szablonu',
    'eqsl.bgSavedNotify': 'Tło eQSL zapisane -- przesuń pola na podglądzie, żeby ułożyć je tak jak na Twojej karcie',
    'eqsl.errUploadImage': 'Błąd wgrywania obrazka',
    'eqsl.confirmRemoveBg': 'Usunąć własne tło? Wrócisz do jednolitego koloru tła.',
    'eqsl.bgRemovedNotify': 'Własne tło usunięte -- wraca jednolity kolor tła',
    'eqsl.errRemoveImage': 'Błąd usuwania obrazka',
    'eqsl.confirmResetPositions': 'Przywrócić domyślne pozycje wszystkich pól?',
    'eqsl.loadingEditor': '⏳ Ładowanie edytora...',
    'eqsl.fieldSenderCallsign': 'Znak (Twój)',
    'eqsl.fieldRecipientCallsign': 'Znak (rozmówca)',
    'eqsl.fieldDate': 'Data',
    'eqsl.fieldTime': 'Czas',
    'eqsl.fieldBand': 'Pasmo',
    'eqsl.fieldMode': 'Emisja',
    'eqsl.fieldRstSent': 'RST wys.',
    'eqsl.fieldRstRecv': 'RST odb.',
    'eqsl.fieldClubName': 'Klub',
    'eqsl.fieldSlogan': 'Slogan',
    // Dashboard propagacyjny
    'prop.sunImage': 'Aktualny obraz Słońca (SDO / NASA)',
    'prop.sunUnavailable': 'Obraz Słońca chwilowo niedostępny',
    'prop.details': 'Dane szczegółowe',
    'prop.sunspots': 'Plamy słoneczne (SN)',
    'prop.xray': 'Rozbłyski (X-ray)',
    'prop.solarWind': 'Wiatr słoneczny',
    'prop.protonFlux': 'Strumień protonów:',
    'prop.electronFlux': 'Strumień elektronów:',
    'prop.day': 'Dzień',
    // Satelity
    'sat.yourLat': 'Twoja szerokość geogr. (lat)',
    'sat.yourLon': 'Twoja długość geogr. (lon)',
    'sat.altitude': 'Wysokość n.p.m. (m, opcjonalnie)',
    'sat.enterCoords': 'Wpisz swoje współrzędne, wybierz satelitę i kliknij „Śledź”.',
    'sat.belowHorizon': 'Pod horyzontem — brak przelotu w najbliższych 24h',
    'sat.distance': 'Odległość',
    'sat.groundTrack': 'Ślad naziemny',
    'sat.backToList': '← Wróć do listy',
    // LiveViews -- pelne
    'live.noPasses': 'Brak nadchodzących przejść w najbliższych 48h',
    'live.noReceivers': 'Brak zapisanych odbiorników — kliknij „⚙️ Zarządzaj listą”',
    'live.noGroups': 'Brak skonfigurowanych grup — administrator może je dodać w Panelu Admina',
    'live.manageList': 'Zarządzaj listą',
    'live.openNewTab': '↗ Otwórz w nowej karcie',
    'live.receiverName': 'Nazwa (np. SP3RC Zielona Góra)',
    'live.giveNameUrl': 'Podaj nazwę i URL odbiornika',
    'live.saveError': 'Błąd zapisu listy odbiorników',
    'live.rise': 'Wschód',
    'live.set': 'Zachód',
    'live.aimAntenna': 'Kliknij, aby naprowadzić antenę na tego satelitę',
    'live.aimHint': '🎯 Kliknij, aby naprowadzić antenę →',
    'live.noCatAgent': 'Brak agenta CAT — wpisz częstotliwość ręcznie',
    'live.playingBg': '🔊 Odtwarzanie kontynuuje się w tle',
    // Admin -- reszta
    'admin.workingAs': '📻 Pracuję jako',
    'admin.altCallsigns': '⚙️ Znaki okolicznościowe',
    'admin.altCallsignsHint': 'Znaki okolicznościowe (oddzielone przecinkami), np.',
    'admin.alsoAdifLotw': '— także w ADIF/LoTW',
    'admin.svxGroupsTab': '🎙️ Grupy SVXLink (zakładka „Na żywo”)',
    'admin.giveNameUrlStream': 'Podaj nazwę i URL strumienia',
    'admin.groupSaveError': 'Błąd zapisu listy grup',
    'admin.clearLogError': 'Błąd czyszczenia logu',
    'admin.groupsSaved': 'Lista grup SVXLink zapisana',
    'admin.settingsSaved': 'Ustawienia zapisane',
    'admin.errSaveSettings': 'Błąd zapisu ustawień',
    'admin.giveTestEmail': 'Podaj adres email do testu',
    'admin.testEmailSent': 'Email testowy wysłany!',
    'admin.testEmailFailed': 'Wysyłka nie powiodła się',
    'admin.errTestEmail': 'Błąd wysyłki testowej',
    'admin.smtpHeading': '📧 Konfiguracja SMTP (reset hasła, weryfikacja email)',
    'admin.imapHeading': '📥 Kopia wysłanych maili w IMAP (folder Sent)',
    'admin.notificationsHeading': '📨 Powiadomienia systemowe',
    'admin.securityHeading': '🔐 Rejestracja i bezpieczeństwo',
    'admin.loggerDefaultsHeading': '📻 Domyślne ustawienia loggera (dla nowych kont)',
    'admin.inactivityHeading': '📧 Przypomnienie o nieaktywności',
    'admin.maintenanceHeading': '🔧 Tryb przerwy technicznej',
    'admin.debugWebsdrHeading': '🐛 Debug WebSDR',
    'admin.adminNotifHeading': '🔔 Powiadomienia administratora (mailem)',
    'admin.systemFeaturesHeading': '🧩 Funkcje systemowe',
    'admin.termsHeading': '📜 Regulamin i kontakt',
    'admin.otherSettingsHeading': '⚙️ Inne ustawienia',
    'admin.smtpHost': 'Host SMTP',
    'admin.port': 'Port',
    'admin.connectionSecurity': 'Zabezpieczenie połączenia',
    'admin.smtpUser': 'Użytkownik SMTP',
    'admin.smtpPassword': 'Hasło SMTP',
    'admin.valueSet': '(ustawione)',
    'admin.fromAddress': 'Adres "Od"',
    'admin.enterToChange': 'Wpisz aby zmienić',
    'admin.smtpSecurityNote': 'To trzy różne, niekompatybilne sposoby -- serwer wspiera zazwyczaj tylko jeden. Błąd "STARTTLS extension not supported" -- przełącz na SSL/TLS (i port 465) albo, jeśli to Twój własny serwer w sieci lokalnej bez TLS wcale, na "Brak".',
    'admin.startTls587': 'STARTTLS (typowo port 587)',
    'admin.ssl465': 'SSL/TLS (typowo port 465)',
    'admin.noneLan': 'Brak (bez szyfrowania -- np. własny serwer w LAN)',
    'admin.ssl993': 'SSL/TLS (typowo port 993)',
    'admin.startTls143': 'STARTTLS (typowo port 143)',
    'admin.imapDesc': 'SMTP samo w sobie NIE zapisuje kopii wysłanej wiadomości -- to normalnie robi program pocztowy. Włącz poniżej, żeby aplikacja po każdej wysyłce (eQSL, powiadomienia, reset hasła itd.) dopisywała kopię do folderu Sent na Twojej skrzynce -- będziesz widzieć w kliencie pocztowym dokładnie to, co poszło.',
    'admin.imapAppendCheckbox': 'Zapisuj kopię wysłanych maili w IMAP',
    'admin.imapHost': 'Host IMAP',
    'admin.imapUser': 'Użytkownik IMAP',
    'admin.imapUserPlaceholder': 'puste = jak SMTP',
    'admin.imapPassword': 'Hasło IMAP',
    'admin.imapPasswordPlaceholder': 'puste = jak SMTP / wpisz aby zmienić',
    'admin.sentFolder': 'Folder Sent',
    'admin.imapFolderNote': 'Nazwa folderu zależy od dostawcy -- np. Gmail używa "[Gmail]/Sent Mail". Jeśli użytkownik/hasło zostaną puste, użyte zostaną dane logowania SMTP powyżej (typowe, gdy to ta sama skrzynka).',
    'admin.telegramBotToken': 'Telegram Bot Token',
    'admin.discordSystemWebhook': 'Discord Webhook -- powiadomienia systemowe (nowe rejestracje)',
    'admin.webhookNote': 'To OSOBNY webhook od tych ustawianych przez userów w zakładce Watchlist (te są do osobistych alertów DX) -- ten tutaj wysyła powiadomienia DLA ADMINA o zdarzeniach systemowych, np. nowych rejestracjach.',
    'admin.registrationOpenLabel': 'Rejestracja nowych kont otwarta (wyłącz dla prywatnej instancji klubowej -- konta dodaje wtedy admin ręcznie/przez SQL)',
    'admin.defaultPublicProfileLabel': 'Nowe konta domyślnie z włączonym publicznym profilem',
    'admin.loginRateLimitLabel': 'Limit prób logowania (na adres IP / 5 min)',
    'admin.maxQsosImportLabel': 'Limit QSO na import ADIF',
    'admin.loggerDefaultsNote': 'Dotyczy tylko PRZYSZŁYCH rejestracji -- nie zmienia niczego u już istniejących userów (każdy z nich może i tak sam to zmienić w Ustawieniach konta).',
    'admin.defaultEqslLabel': 'Nowe konta domyślnie z włączoną automatyczną wysyłką eQSL przy zapisie QSO',
    'admin.inactivityNote': 'Gdy user nie logował się przez podaną liczbę dni, dostaje mailowe przypomnienie ("nie logowałeś się od X dni"). Kolejne przypomnienie idzie dopiero po upływie tego samego okresu, nie codziennie -- resetuje się przy kolejnym logowaniu.',
    'admin.sendInactivityReminderLabel': 'Wysyłaj przypomnienie o nieaktywności',
    'admin.inactivityThresholdLabel': 'Próg nieaktywności (dni)',
    'admin.maintenanceModeLabel': 'Włącz przerwę techniczną (blokuje logowanie zwykłym userom -- Ty jako admin nadal możesz się zalogować)',
    'admin.maintenanceMessageLabel': 'Komunikat dla userów',
    'admin.maintenanceMessagePlaceholder': 'Serwis jest tymczasowo niedostępny -- wracamy o 20:00',
    'admin.debugWebsdrLabel': 'Zbieraj logi diagnostyczne z zakładki WebSDR (widoczne tylko dla admina, w zakładce "🐛 Debug")',
    'admin.debugWebsdrNote': 'Gdy włączone, każda próba wczytania odbiornika WebSDR (przez każdego użytkownika) jest logowana -- adres odbiornika, częstotliwość/mode, czy wystartowało, i wykryte przyczyny problemów (np. niezgodność protokołu http/https). Domyślnie wyłączone, żeby nie zbierać danych o aktywności userów bez potrzeby.',
    'admin.svxGroupsNote': 'Lista grup widoczna dla WSZYSTKICH użytkowników w zakładce "🎙️ SVXLink". Każda grupa wymaga URL-a strumienia Icecast/Shoutcast (np.',
    'admin.svxGroupsNote2': ') -- patrz README, sekcja "SVXLink", po przepis na mostek z SVXLink do Icecast.',
    'admin.groupNamePlaceholder': 'Nazwa grupy (np. TG91 PL)',
    'admin.groupDescPlaceholder': 'Opis (opcjonalnie)',
    'admin.adminNotifNote': 'Wysyłane mailem do',
    'admin.adminNotifNoteBold': 'wszystkich',
    'admin.adminNotifNote2': 'kont z uprawnieniami administratora, które mają ustawiony adres email (nie tylko do jednego, sztywno wybranego konta). Wymaga skonfigurowanego SMTP wyżej.',
    'admin.systemFeaturesNote': 'Globalne przełączniki funkcji dla wszystkich użytkowników. Wyłączenie wstrzymuje daną funkcję w całym systemie (np. gdy chcesz ograniczyć ruch lub SMTP ma problem).',
    'admin.termsNoteA': 'Widoczne publicznie pod adresem',
    'admin.termsNoteB': '-- bez logowania, dostępne też z ekranu rejestracji. Treść poniżej to wygenerowany szablon -- dostosuj go do swojej instalacji (wspiera prosty markdown:',
    'admin.termsNoteC': ',',
    'admin.termsNoteD': ').  Jeśli udostępniasz instalację szerszej grupie osób, rozważ konsultację z prawnikiem w zakresie zgodności z RODO -- to nie jest gotowy dokument prawny.',
    'admin.markdownHeaderExample': '# nagłówek',
    'admin.orgNameLabel': 'Nazwa klubu/organizacji (opcjonalnie)',
    'admin.contactEmailLabel': 'Email kontaktowy',
    'admin.appUrlLabel': 'URL aplikacji (do linków w mailach)',
    'admin.saveSettingsBtn': '✓ Zapisz ustawienia',
    'admin.sendTestEmailHeading': 'WYŚLIJ TESTOWY EMAIL (sprawdź czy SMTP działa):',
    'admin.sendTestBtn': '📤 Wyślij test',
    'admin.newPasswordSetFor': 'Nowe hasło ustawione dla',
    'admin.resetLinkSentTo': 'Link resetu wysłany na',
    'admin.resetLinkGenFailed': 'Link wygenerowany, ale wysyłka email nie powiodła się (sprawdź SMTP)',
    'admin.errResetPassword': 'Błąd resetu hasła',
    'admin.sendResetEmail': 'Wyślij link mailem',
    'admin.setManually': 'Ustaw ręcznie',
    'admin.sendResetEmailInfo': 'Wyśle standardowy link resetu hasła na adres',
    'admin.smtpRequired': '(wymaga skonfigurowanego SMTP).',
    'admin.newPasswordLabel': 'Nowe hasło',
    'admin.minChars': 'min. 6 znaków',
    'admin.executeBtn': 'Wykonaj',
    'admin.editAccountModalTitle': 'Dane konta',
    'admin.accountDataSaved': 'Dane konta',
    'admin.savedSuffix': 'zapisane',
    'admin.errSave': 'Błąd zapisu',
    'admin.editAccountInfo': 'Bezpośrednia zmiana danych konta -- np. poprawienie literówki w znaku/emailu zgłoszonej przez usera. Zmiana znaku NIE przepisuje historii QSO (znaki DX stacji w logu się nie zmieniają).',
    'admin.callsignLabel': 'Znak wywoławczy',
    'admin.emailLabel': 'Email',
    'admin.homeLocatorLat': 'Lokator domowy -- szer.',
    'admin.homeLocatorLon': 'Lokator domowy -- dł.',
    'admin.errLoadQsos': 'Błąd ładowania QSO',
    'admin.qsoSaved': 'QSO zapisane',
    'admin.errSaveQso': 'Błąd zapisu QSO',
    'admin.confirmDeleteQso': 'Usunąć QSO',
    'admin.confirmDeleteQsoSuffix': '? Trafi do kosza na 30 dni.',
    'admin.qsoDeleted': 'QSO usunięte (w koszu 30 dni)',
    'admin.errDeleteQso': 'Błąd usuwania QSO',
    'admin.noQsos': 'Brak QSO',
    'admin.colDateTime': 'Data/Czas',
    'admin.colBand': 'Pasmo',
    'admin.colMode': 'Emisja',
    'admin.colFreq': 'Częst.',
    'admin.colRst': 'RST S/R',
    'admin.bandAutoTitle': 'Pasmo liczy się automatycznie z częstotliwości',
    'admin.freqAutoTitle': 'Zmiana częstotliwości automatycznie przeliczy pasmo',
    'admin.prevPageShort': '‹ Poprzednia',
    'admin.nextPageShort': 'Następna ›',
    'admin.restoreBackupTitle': 'Przywróć backup',
    'admin.restoreWarning': 'To NADPISZE całą bieżącą bazę danych zawartością pliku',
    'admin.restoreWarning2': 'Wszystko zapisane PO tej dacie backupu zostanie utracone. Operacja jest nieodwracalna (poza przywróceniem z jeszcze innego backupu). Aplikacja przejdzie na chwilę w tryb przerwy technicznej.',
    'admin.typeFilenameToConfirm': 'Wpisz dokładnie nazwę pliku, aby potwierdzić',
    'admin.restoringInProgress': '⏳ Przywracanie...',
    'admin.restoreOverwriteBtn': 'Przywróć (nadpisz bazę)',
    'admin.restoredSuccessfully': '✅ Przywrócono pomyślnie.',
    'admin.dbRestored': 'Baza przywrócona z backupu',
    'admin.errRestore': 'Błąd przywracania',
    'admin.closeBtn': 'Zamknij',
    'admin.resetPasswordTitle': 'Reset hasła',
    'admin.queueEmpty': 'Kolejka jest pusta — wszystko wysłane.',
    'admin.qsoSent': 'QSO wysłane!',
    'admin.offlineQueueTitle': 'Kolejka offline',
    'admin.offlineQueueDesc': 'QSO zapisane lokalnie (np. w terenie, bez internetu), jeszcze nie wysłane do bazy. Jeśli przy jakimś widzisz błąd poniżej -- serwer go ODRZUCIŁ (nie brak sieci) -- można spróbować wysłać ponownie, albo usunąć i wpisać ręcznie w formularzu.',
    'admin.confirmDeleteQueueItem': 'Usunąć to QSO z kolejki offline? Nie zostanie zapisane do logu.',
    'admin.errStatus': 'Błąd',
    'admin.stillNoConnection': 'Wciąż brak połączenia z serwerem',
    'admin.failedToSend': 'Nie udało się wysłać',
    'admin.noCallsign': '(brak znaku)',
    'admin.retryBtn': '↻ Spróbuj wysłać',
    'admin.dismissAnnouncement': 'Schowaj to ogłoszenie',
    'admin.user': 'Użytkownik',
    'admin.delete': 'Usuń',
    'admin.featuresVisibleTo': 'Funkcje poniżej są widoczne dla',
    'admin.regularUsers': 'zwykłych użytkowników',
    'admin.adminsAlways': 'administratorów zawsze',
    'admin.enableWhenReady': '. Włącz dopiero, gdy funkcja jest gotowa.',
    'admin.webSdrDiag': 'Zbieraj logi diagnostyczne z zakładki WebSDR',
    'mod.canSuspend': 'zawieszać/odwieszać zwykłe konta',
    // Dokonczenie -- wszystkie pozostale
    'common.loadingSpots': '⏳ Ładowanie spotów...',
    'common.loadingNews': '⏳ Ładowanie wiadomości...',
    'common.loadingRanking': '⏳ Ładowanie rankingu...',
    'common.loadingDxped': '⏳ Ładowanie ekspedycji...',
    'common.loadingRepeaters': 'Ładowanie przemienników...',
    'common.countingCountries': '⏳ Liczenie krajów...',
    'common.clear': 'Wyczyść',
    'common.range': 'Zasięg:',
    'common.connecting': '○ łączenie...',
    'common.upcoming': '📅 Nadchodzące',
    'common.sourceUnavailable': 'Źródło chwilowo niedostępne z serwera.',
    'common.backToHamlogger': '← Wróć do HamLoggera',
    'common.backToAccount': '← Wróć do swojego konta',
    // eQSL
    'eqsl.markSent': '✓ Oznacz niewysłane jako wysłane',
    'eqsl.markAsSent': 'Oznacz jako wysłane',
    'eqsl.customBg': '🖼️ Własne tło (opcjonalnie)',
    'eqsl.removeBg': 'Usuń tło, wróć do koloru',
    'eqsl.fieldPositions': '📍 Pozycje pól',
    'eqsl.resetPositions': '↺ Przywróć domyślne pozycje',
    'eqsl.bgSaved': 'Tło eQSL zapisane',
    'eqsl.usingCustomBg': 'Aktualnie używane jest własne tło.',
    // CW
    'cw.decoder': 'Dekoder CW (nasłuch)',
    'cw.startListening': 'Zacznij nasłuch',
    'cw.trainer': 'Trenażer CW',
    'cw.showAnswer': 'Pokaż odpowiedź',
    'cw.customText': 'Własny tekst',
    'cw.practicing': 'Ćwiczysz:',
    'cw.listenAndWrite': 'Posłuchaj i zapisz, co usłyszałeś. Potem kliknij „Pokaż odpowiedź”.',
    // Profil / API
    'profile.hamProfile': 'Profil krótkofalarski',
    'profile.sessionSecurity': 'Bezpieczeństwo sesji',
    'profile.apiToken': 'Twój token API',
    'profile.regenerate': 'Wygeneruj nowy (odwołuje stary)',
    'profile.revoke': 'Odwołaj',
    'profile.readOnly': 'tylko do odczytu Twojego własnego loga',
    'profile.monthlySummary': 'Wysyłaj mi miesięczne podsumowanie logu mailem',
    'profile.autoEqsl': 'Domyślnie zaznaczaj „Wyślij eQSL” przy nowym QSO w loggerze',
    'profile.emailOptional': 'Adres email (opcjonalnie -- jeśli QRZ nie ma publicznego)',
    'profile.loadError': 'Błąd ładowania profilu -- spróbuj ponownie później.',
    'profile.actingAs': '🎭 Działasz jako',
    // Inne
    'prop.whereToTx': 'Gdzie nadawać teraz?',
    'prop.noBandData': 'Brak danych warunków pasm w tej chwili',
    'prop.rateRoute': 'Oceń które pasmo może być otwarte na tej trasie',
    'dxccmap.missingTop': '🎯 Najbardziej poszukiwane, których Ci brakuje',
    'dxccmap.openMostWanted': '💡 Otwórz zakładkę „🏆 Most Wanted”, aby zobaczyć, których poszukiwanych krajów Ci brakuje.',
    'repeater.removeFav': 'Usuń z ulubionych',
    'admin.firstAdmin': '🛠️ Zostałeś automatycznie ustawiony jako pierwszy administrator systemu!',
    'live.httpWarning': '⚠️ Ten odbiornik używa http:// -- jeśli widzisz pustą ramkę, otwórz go w nowej karcie.',
  },
  en: {
    // Navigation -- groups
    'nav.dashboard': '🏠 Dashboard',
    'nav.logger': '🎙 Logger',
    'nav.journal': '📒 Log',
    'nav.live': '📡 Live',
    'nav.awards': '🏆 Awards',
    'nav.info': 'ℹ️ Info',
    'nav.community': '🤝 Community',
    'nav.tools': '🛠️ Tools',
    'nav.admin': '🛠️ Admin',
    'nav.moderation': '🛡️ Moderation',
    // Navigation -- items
    'nav.logbook': '📖 QSO Logbook',
    'nav.qsomap': '🗺️ QSO Map',
    'nav.stats': '📊 Statistics',
    'nav.goals': '🏆 Goals & badges',
    'nav.portable': '⛺ Portable / POTA',
    'nav.dxccmap': '🌏 DXCC Map',
    'nav.analysis': '📈 Time Analysis',
    'nav.shared': '👥 Shared Logbook',
    'nav.eqsl': '🎨 eQSL card designer',
    'nav.cluster': '🌐 DX Cluster',
    'nav.dxneeded': '🎯 Needed Hunter',
    'nav.watchlist': '⭐ Watchlist',
    'nav.pota': '🏞️ POTA/SOTA',
    'nav.wwff': '🌲 WWFF',
    'nav.pskreporter': '📶 Who hears me',
    'nav.satellites': '🛰️ Satellites',
    'nav.websdr': '🎧 WebSDR',
    'nav.svxlink': '🔊 SVXLink',
    'nav.weather': '🌦️ Weather',
    'nav.propagation': '☀️ HF Propagation',
    'nav.activationplanner': '🏕️ Activation planner',
    'nav.aprs': '📍 APRS',
    'nav.diplomas': '🏆 Awards',
    'nav.news': '📰 News',
    'nav.contests': '🏁 Contests',
    'nav.dxpeditions': '✈️ DXpeditions',
    'nav.mostwanted': '💎 Most Wanted',
    'nav.neighbors': '🏘️ Neighbours',
    'nav.nets': '📋 Net control',
    'nav.antenna': '📐 Antenna Calculator',
    'nav.cwdecoder': '🔤 CW Decoder',
    'nav.cwtrainer': '🎓 CW Trainer',
    'nav.pathcalc': '📏 DX Path Calculator',
    'nav.qsorate': '⏱️ QSO Rate Meter',
    'nav.results': '🏅 Results',
    'nav.qsl': '📨 QSL',
    'nav.plan': '📅 Plan',
    'nav.upload': '📤 Upload to services',
    'nav.qslpaper': '📇 Paper QSL',
    'nav.trash': '🗑️ Trash',
    'nav.mypropagation': '🧭 My propagation',
    'nav.station': '🎛️ My equipment',
    'nav.year': '🎉 Year in review',
    'nav.swl': '👂 Listening log (SWL)',
    'nav.skeds': '⏰ Skeds',
    'nav.dxccmatrix': '🔢 DXCC matrix',
    'nav.azimuthal': '🔭 Azimuthal map',
    'nav.bandmap': '📊 Band map',
    'nav.keyer': '📣 Voice/CW keyer',
    'nav.beacons': '📡 NCDXF beacons', 'nav.alertrules': '🔔 Alert rules', 'nav.chat': '💬 Chat', 'nav.market': '🛒 Gear market', 'nav.ranking': '🥇 Ranking', 'nav.exam': '🎓 License exam',
    'nav.liveroster': '📻 Live Roster', 'nav.agentdiag': '🩺 Agent diagnostics', 'nav.wsjtx': '🎛️ WSJT-X remote',
    // Common buttons / labels
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.refresh': 'Refresh',
    'common.loading': 'Loading...',
    'common.search': 'Search',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.all': 'All',
    'common.none': 'None',
    'common.logout': 'Log out',
    // Logger
    'logger.activating': 'Activating',
    'logger.endActivation': 'End activation',
    'logger.newQso': '🎙 New QSO',
    'logger.callsign': 'Callsign',
    'logger.frequency': 'Frequency (MHz)',
    'logger.mode': 'Mode',
    'logger.band': 'Band',
    'logger.rstSent': 'RST sent',
    'logger.rstRecv': 'RST received',
    'logger.name': 'Name',
    'logger.qth': 'QTH',
    'logger.date': 'Date',
    'logger.country': 'Country',
    'logger.grid': 'Grid locator',
    'logger.notes': 'Notes',
    'logger.power': 'Power (W)',
    'logger.saveQso': 'Save QSO',
    'logger.workingAs': '📻 Operating as',
    'logger.ownCallsign': '(own)',
    'logger.recentQsos': 'Recent QSOs',
    'logger.sessionQsos': 'QSOs',
    // Statistics / awards
    'awards.progress': '🏅 Award progress',
    'awards.missing': 'missing',
    'awards.hideMissing': 'hide missing',
    'awards.missingZones': 'Missing CQ zones',
    'awards.missingStates': 'Missing US states',
    'awards.fiveBandDxcc': 'DXCC on five bands (80/40/20/15/10 m)',
    'awards.countriesAllFive': 'countries on all 5',
    // Logger -- extended
    'logger.editQso': '✏️ Edit',
    'logger.duplicate': 'You already worked this station today on this band/mode',
    'logger.newCountry': 'NEW COUNTRY',
    'logger.newBand': 'new band',
    'logger.newMode': 'new mode',
    'logger.workedBefore': 'Worked before',
    'logger.times': 'times',
    'logger.qrzLookup': 'Look up on QRZ',
    'logger.distance': 'Distance',
    'logger.bearing': 'Bearing',
    // Logbook
    'logbook.title': '📒 Logbook',
    'logbook.search': 'Search callsign...',
    'logbook.allBands': 'All bands',
    'logbook.allModes': 'All modes',
    'logbook.export': 'Export ADIF',
    'logbook.import': 'Import ADIF',
    'logbook.selected': 'Selected',
    'logbook.deselect': 'Deselect',
    'logbook.noQsos': 'No QSOs in the logbook',
    // Statistics
    'stats.total': 'Total QSOs',
    'stats.unique': 'Unique callsigns',
    'stats.countries': 'Countries',
    'stats.bands': 'Bands',
    'stats.modes': 'Modes',
    // QSL
    'qsl.title': 'Paper QSL',
    'qsl.toSend': 'To send',
    'qsl.awaiting': 'Awaiting',
    'qsl.received': 'Received',
    'qsl.bureau': '📮 Bureau',
    'qsl.direct': 'Direct',
    'qsl.manager': '👤 Manager',
    'qsl.labels': 'Labels',
    'qsl.cards': 'QSL Cards',
    'qsl.print': 'Print',
    'qsl.markSent': 'Mark as sent',
    'qsl.markReceived': '📬 Mark as received',
    // Errors / messages
    'error.generic': 'An error occurred',
    'error.network': 'Connection error',
    'error.notFound': 'Not found',
    'msg.saved': 'Saved',
    'msg.deleted': 'Deleted',
    'msg.updated': 'Updated',
    // Admin / moderation
    'admin.users': 'Users',
    'admin.settings': 'Settings',
    'admin.overview': 'Overview',
    'admin.announcements': 'Announcements',
    'admin.activityLog': 'Activity log',
    'admin.backups': 'Backups',
    'admin.role': 'Role',
    'admin.status': 'Status',
    'admin.actions': 'Actions',
    'admin.suspend': '⛔ Suspend',
    'admin.unsuspend': '✅ Unsuspend',
    'admin.active': '✅ Active',
    'admin.suspended': '⛔ Suspended',
    // Live
    'live.spots': 'Spots',
    'live.activator': 'Activator',
    'live.spotter': 'Spotter',
    'live.comment': 'Comment',
    'live.freq': 'Frequency',
    'live.noSpots': 'No active spots',
    // Awards / community
    'community.neighbors': 'Neighbours',
    'community.sharedLog': 'Shared logbook',
    'community.distance': 'Distance',
    // 2FA
    '2fa.title': 'Two-factor authentication (2FA)',
    '2fa.enable': 'Enable 2FA',
    '2fa.disable': 'Disable 2FA',
    '2fa.code': '2FA code',
    '2fa.backupCodes': 'Backup codes',
    // Log health
    'health.title': '🩺 Log quality check',
    'health.scan': 'Check log',
    'health.clean': 'Log is clean',
    'health.issues': 'issues',
    // QSL -- full
    'qsl.desc': 'Paper QSL workflow: mark QSOs for sending, choose the route (bureau/direct), print labels, and mark as received once the card arrives.',
    'qsl.allRoutes': 'All routes',
    'qsl.route': 'Route',
    'qsl.unqueue': '✕ Remove from queue',
    'qsl.emptyToSend': 'Queue is empty. Add QSOs from the logbook (select QSOs → "QSL to send").',
    'qsl.emptyAwaiting': 'Nothing is awaiting a reply.',
    'qsl.emptyReceived': 'No cards received yet.',
    'qsl.labelsTitle': 'QSL labels',
    'qsl.labelsDesc': 'One label = one station (several QSOs with the same operator fit on a single card).',
    'qsl.cardsTitle': 'Printable QSL cards',
    'qsl.cardsDesc': 'Styled like your eQSL design (colors, background, club, slogan) -- set it up under "eQSL Design" if you haven\'t yet.',
    'qsl.back': '← Back',
    'qsl.sentDate': 'Sent',
    'qsl.recvDate': 'Received',
    'qsl.selectFirst': 'Select QSOs first',
    'qsl.noQueue': 'No QSOs in the sending queue',
    // Log health -- full
    'health.desc': 'Finds errors that block awards and LoTW. Worth running before uploading.',
    'health.scanning': 'Scanning...',
    'health.cleanMsg': 'Log is clean — no problems found!',
    'health.cleanFull': 'Log is clean — scanned {n} QSOs, no problems found.',
    'health.foundIssues': 'Found',
    'health.inQsos': 'in',
    'health.clickCategory': 'Click a category to see the details.',
    'health.failed': 'Could not check the log',
    'health.freqBandMismatch': 'Frequency doesn\'t match the band',
    'health.freqBandMismatchHint': 'The band in the log doesn\'t match the frequency -- fix the band (bulk edit).',
    'health.freqOutOfBand': 'Frequency outside amateur bands',
    'health.freqOutOfBandHint': 'Likely a typo when entering the QSO.',
    'health.badGrid': 'Invalid locator',
    'health.badGridHint': 'Wrong format blocks VUCC awards and distance calculations.',
    'health.missingCountry': 'Missing country (doesn\'t count for DXCC)',
    'health.missingCountryHint': 'Fill in the country -- a QSO without one doesn\'t count for DXCC.',
    'health.futureDate': 'QSO date is in the future',
    'health.futureDateHint': 'Entry or import error -- LoTW will reject such a QSO.',
    'health.duplicates': 'Possible duplicates',
    'health.duplicatesHint': 'Same callsign, band, and mode within 5 minutes.',

    'myprop.continentEU': 'Europe',
    'myprop.continentNA': 'North America',
    'myprop.continentSA': 'South America',
    'myprop.continentAS': 'Asia',
    'myprop.continentAF': 'Africa',
    'myprop.continentOC': 'Oceania',
    'myprop.confHigh': 'reliable — large sample',
    'myprop.confMedium': 'indicative — medium sample',
    'myprop.confLow': 'take with caution — small sample',
    'myprop.confNotEnough': 'not enough QSOs to conclude anything',
    'myprop.errLoad': 'Could not load the analysis',
    'myprop.title': 'Personal propagation',
    'myprop.desc': 'Propagation models tell you what should work under typical station assumptions. This view shows what actually worked -- from your antenna, your QTH, your power. It\'s a historical record, not a forecast -- but after a year of logging it\'s often more accurate than the model.',
    'myprop.tabNow': 'What tends to be open now',
    'myprop.tabTarget': 'When do I work a specific target',
    'myprop.utcHour': 'UTC hour',
    'myprop.now': 'Now',
    'myprop.calculating': '⏳ Calculating...',
    'myprop.noQsosWindow': 'No QSOs in this time window. Try a different hour -- or you just don\'t have much data for this time yet.',
    'myprop.qsosFromWindow': 'Your QSOs from the',
    'myprop.selectTarget': '— select a country from your log —',
    'myprop.qsosInLog': 'QSOs in log',
    'myprop.bestHours': 'Best hours:',
    'myprop.band': 'Band',
    'myprop.heatmapNote': 'These numbers are your successful QSOs in that UTC hour. Bright cells = times you actually reach that target.',
    'myprop.noQsosTarget': 'No QSOs with this target.',

    'sessions.justNow': 'just now',
    'sessions.minAgo': 'min ago',
    'sessions.hoursAgo': 'hours ago',
    'sessions.daysAgo': 'days ago',
    'sessions.title': 'Where I\'m logged in',
    'sessions.desc': 'List of devices that have logged into your account. If you see something you don\'t recognize -- change your password and log out everywhere.',
    'sessions.noSessions': 'No saved sessions.',
    'sessions.thisSession': '● THIS SESSION',
    'sessions.logoutAll': 'Log out of all devices',
    'sessions.confirmTitle': 'Log out of all devices?',
    'sessions.confirmDesc': 'All sessions (including this one) will be closed. You\'ll need to log in again. Confirm with your password.',
    'sessions.passwordPlaceholder': 'Your password',
    'sessions.confirm': 'Confirm',
    'sessions.cancel': 'Cancel',
    'sessions.loggedOutAll': 'Logged out of all devices',
    'sessions.errGeneric': 'Error',

    'ant.gardenGarden': '🌳 Garden',
    'ant.gardenRooftop': '🏢 Roof',
    'ant.gardenBalcony': '🏠 Balcony',
    'ant.gardenAttic': '🏚️ Attic',
    'ant.errLoadCalc': 'Could not load calculator data',
    'ant.bands': 'Bands',
    'ant.spaceType': 'Space type',
    'ant.supports': 'Support points',
    'ant.power': 'Power (W)',
    'ant.hasTrees': 'I have trees (anchor points)',
    'ant.stealthReq': 'Stealth required',
    'ant.calculating': '⏳ Calculating...',
    'ant.calcAntennas': 'Calculate antennas',
    'ant.selectOneBand': 'Select at least one band',
    'ant.errCalc': 'Calculation error',
    'ant.tabResults': 'Results',
    'ant.tabTerrainMap': 'Terrain map',
    'ant.tabViz': 'Visualisation',
    'ant.tabCoax': 'Cable/Feedline',
    'ant.engineDesc': 'The engine will evaluate antenna types (dipole, Inverted-V, EFHW, vertical, loops, Yagi...) against your constraints and calculate dimensions.',
    'ant.feed': 'Feed:',
    'ant.noVizForType': 'No visualisation available for this type.',
    'ant.selectAntennaViz': 'Select an antenna in the "Results" tab to see the dimension visualisation.',
    'ant.cableType': 'Cable type',
    'ant.swrAtAntenna': 'SWR at antenna',
    'ant.matchedLoss': 'Matched loss',
    'ant.hintStandingWave': 'accounting for standing-wave heating',
    'ant.powerAtAntenna': 'Power at antenna',
    'ant.powerLoss': 'Power loss',
    'ant.swrAtTx': 'SWR at transmitter',
    'ant.hintLowerSwr': 'lower than at the antenna -- the cable masks SWR with loss',
    'ant.recommendation': 'Recommendation:',
    'ant.cableComparison': 'Cable comparison',
    'ant.cable': 'Cable',
    'ant.lossDb': 'Loss (dB)',
    'ant.powerAtAntennaW': 'Power at antenna (W)',
    'ant.errCoaxCalc': 'Cable calculation error',
    'ant.calculateBtn': '🔌 Calculate',
    'ant.errLocationNotFound': 'Location not found',
    'ant.errSearch': 'Search error',
    'ant.searchBtn': 'Search',
    'ant.elevation': 'Elevation:',
    'ant.noDataShort': 'no data',
    'ant.aboveSeaLevel': 'm a.s.l.',

    'pota.activeSpots': 'Active spots',
    'pota.errSpots': 'Error fetching POTA spots',
    'pota.errConnection': 'Error connecting to POTA API',
    'pota.countryPL': 'Poland', 'pota.countryAll': 'All countries',
    'pota.countryDE': 'Germany', 'pota.countryCZ': 'Czechia', 'pota.countrySK': 'Slovakia',
    'pota.countryUA': 'Ukraine', 'pota.countryLT': 'Lithuania', 'pota.countryAT': 'Austria',
    'pota.countryIT': 'Italy', 'pota.countryFR': 'France', 'pota.countryES': 'Spain',
    'pota.countryGB': 'UK', 'pota.countryUS': 'USA',
    'pota.source': 'Source: api.pota.app (public API)',
    'pota.refresh': '↻ Refresh',
    'pota.noActive': 'No active activations',
    'pota.noActiveForCountry': 'for country',
    'pota.rightNow': 'right now',
    'pota.activator': 'Activator',
    'pota.comment': 'Comment',
    'pota.logBtn': 'Log',
    'pota.qsyTitle': 'Tune the radio to this frequency (requires the CAT agent)',
    'pota.loadingStats': '⏳ Loading statistics...',
    'pota.errStats': 'Error fetching POTA statistics',
    'pota.fieldActivations': 'Activations',
    'pota.fieldActivatorQsos': 'QSOs (activator)',
    'pota.fieldActivatorParks': 'Unique parks (activator)',
    'pota.fieldHunterQsos': 'QSOs (hunter)',
    'pota.fieldHunterParks': 'Unique parks (hunter)',
    'pota.fieldEndorsements': 'Endorsements',
    'pota.officialStats': 'Official POTA statistics',
    'pota.officialStatsInfo': 'POTA only publicly exposes aggregate numbers. Detailed history of "which park, when" requires logging into',
    'pota.officialStatsInfo2': 'and a manual export -- an external app can\'t fetch this without you logging into their site. Instead, below we show a summary built from',
    'pota.yourLogSummary': 'your own log in HamLogger',
    'pota.fromYourLog': '📒 From your HamLogger log',
    'pota.qsosWithRef': 'QSOs with a POTA reference:',
    'pota.uniqueParks': 'Unique parks:',
    'pota.date': 'Date',
    'pota.role': 'Role',
    'pota.bands': 'Bands',
    'pota.modes': 'Modes',
    'pota.activation': '🏕️ Activation',
    'pota.hunt': '🎯 Hunt',
    'pota.noQsosWithField': 'No QSOs with the POTA field filled in in your log. Fill in the "POTA ref" field in the logger form ("Contest/award fields" section) during an activation, or click "📋 Log" on an activator spot in the "Active spots" tab.',
    'planner.title': '🗓️ POTA/SOTA Activation Planner',
    'planner.desc': 'Pick a location (manually or by POTA park reference) and a date -- get an hourly day/night/grayline breakdown with suggested bands, plus a solar activity forecast (SFI/A/K) from NOAA if the date falls within the 27-day window.',
    'planner.refLabel': 'POTA reference',
    'planner.latLabel': 'Latitude',
    'planner.lonLabel': 'Longitude',
    'planner.dateLabel': 'Date',
    'planner.runBtn': 'Calculate',
    'planner.errNoRef': 'Enter a park reference',
    'planner.errLookup': 'Could not find a park with that reference',
    'planner.parkFound': 'Found:',
    'planner.errNoCoords': 'Coordinates required (enter manually or look up a park by reference)',
    'planner.errLoad': 'Could not calculate the activation plan',
    'planner.forecastFor': 'Forecast for',
    'planner.noForecast': "The selected date is outside NOAA's 27-day forecast window -- only the day/night breakdown (astronomical, always accurate) is shown below.",
    'planner.colHourUtc': 'UTC hour',
    'planner.colPhase': 'Phase',
    'planner.colElevation': 'Sun elevation',
    'planner.colBands': 'Suggested bands',
    'planner.phase.day': 'Day',
    'planner.phase.night': 'Night',
    'planner.phase.grayline': 'Grayline',
    'planner.currentConditionsNote': 'For reference, conditions RIGHT NOW:',
    'planner.currentConditionsHint': "(not a forecast for the selected date -- just a reference point).",
    'aprs.title': '📍 APRS -- last position',
    'aprs.desc': 'Look up a callsign\'s last reported position via APRS-IS. Read-only -- this feature never sends any position or messages.',
    'aprs.placeholder': 'Callsign (e.g. SQ7SE-9)',
    'aprs.searchBtn': 'Search',
    'aprs.errLoad': 'Could not fetch the position from APRS-IS',
    'aprs.foundLabel': 'Last position:',

    'psk.lastHour': 'Last hour · pskreporter.info',
    'psk.errConnection': 'Error connecting to PSK Reporter',
    'psk.noReportsInfo': 'No reports in the last hour. Only works for digital modes (FT8/FT4/JS8 etc.) decoded by networked receivers (e.g. WSJT-X users with PSK Reporter Spotting).',
    'psk.receivedBy': 'Received by',
    'psk.locator': 'Locator',

    'sat.errPasses': 'Error fetching satellite passes',
    'sat.now': 'NOW!',
    'sat.in': 'in',
    'sat.subtitle': 'SGP4 + Celestrak orbital data · your location from your profile',
    'sat.refresh': '↻ Refresh',
    'sat.noPasses': 'No upcoming passes in the next 48h (or no satellite from the list is currently active in the Celestrak catalog)',
    'sat.qualityHigh': 'high',
    'sat.qualityMedium': 'medium',
    'sat.qualityLow': 'low',
    'sat.qualityTitle': 'Peak elevation: high ≥30°, medium ≥10°, low <10° (still radio-usable)',
    'sat.peak': 'Peak',
    'sat.duration': 'Duration',
    'sat.morePasses': 'more passes in the next 48h',

    'websdr.integration': 'OpenWebRX integration (WebSocket, in an iframe)',
    'websdr.mode': 'Mode',
    'websdr.fromRadio': 'From radio',
    'websdr.fromRadioTitle': 'Requires the CAT agent to be running',
    'websdr.manageDesc': 'The list below shows example, publicly available OpenWebRX receivers -- they may occasionally be offline (typical for hobbyist receivers). Add your own, found e.g. at',
    'websdr.addBtn': '+ Add',
    'websdr.httpWarningTitle': 'http:// -- in some browsers this may fail to load in this view (mixed content), then use the \'open in new tab\' button',
    'websdr.tunedTo': 'Tuned to',
    'websdr.close': '✕ Close',
    'websdr.httpWarning': '⚠️ This receiver uses http:// -- if you see an empty frame below, click "↗ Open in new tab" (always works).',
    'websdr.mixedContentTitle': 'Full navigation in a new tab is never subject to mixed-content blocking -- always works, regardless of http/https',

    'svx.groupsBy': 'Talkgroup list defined by the administrator',
    'svx.errGroups': 'Error fetching the group list',
    'svx.noGroups': 'No talkgroups configured -- an administrator can add them in Admin Panel → Settings.',
    'svx.bgPlayback': '🔊 Playback continues in the background (widget in the bottom-left corner) even after switching to another tab.',
    'svx.streamErr': 'Could not load the stream',
    'svx.streamErrHint': '-- check whether the streaming server is running',
    'svx.logQso': 'Log QSO',
    // 2FA -- full
    '2fa.recommended': 'Your account has elevated privileges. Enabling 2FA is strongly recommended — admin and moderator accounts are the main target of attacks.',
    '2fa.isEnabled': '✅ 2FA is enabled',
    '2fa.codeRequired': 'A code from your app is required at login. Backup codes remaining:',
    '2fa.disableConfirm': 'Disable 2FA?',
    '2fa.disableDesc': 'The account will lose extra protection. Confirm with your password.',
    '2fa.password': 'Your password',
    '2fa.intro': 'A second factor (a code from an app) protects your account even if someone learns your password. Works with Google Authenticator, Aegis, 1Password and others.',
    '2fa.step1': '1. Scan the code in your authenticator app',
    '2fa.step2': '2. Enter the code from the app to confirm',
    '2fa.cantScan': "Can't scan? Enter it manually:",
    '2fa.confirmEnable': 'Confirm and enable',
    '2fa.saveNow': '🔑 Backup codes — save them NOW',
    '2fa.backupDesc': 'This is your only lifeline if you lose your phone. Each works once. You will not see them again — store them safely.',
    '2fa.copy': 'Copy',
    '2fa.savedClose': 'Saved — close',
    // Info / Live views -- full
    'news.title': 'Amateur radio news',
    'news.desc': 'Latest news from the amateur radio world, gathered from several sources in one place.',
    'news.empty': 'No news to display (sources may be temporarily unavailable).',
    'contests.title': 'Contest calendar',
    'contests.desc': 'Ongoing and upcoming amateur radio contests (next 30 days).',
    'contests.live': 'Running now',
    'contests.remind': 'Remind me', 'contests.remindSaved': 'Reminder set — you will get a push notification', 'contests.remindBefore': 'Remind before start:', 'contests.myReminders': 'My reminders',
    'contests.upcoming': 'Upcoming',
    'contests.descLink': 'Click the name to see the rules on the source page.',
    'contests.errLoad': 'Could not load the contest calendar',
    'contests.loadingCal': 'Loading calendar...',
    'contests.noContests': 'No contests to display. The source may be temporarily unavailable — check status below.',
    'contests.liveBadge': 'LIVE',
    'contests.today': 'today',
    'contests.tomorrow': 'tomorrow',
    'contests.inDays': 'in',
    'contests.days': 'days',
    'dxped.title': 'DXpeditions',
    'dxped.desc': 'Announced DX operations (ongoing and upcoming, up to 90 days).',
    'dxped.activeNow': 'Active now',
    'dxped.descFull': 'Announced DX operations (ongoing and upcoming, up to 90 days). Data from the DXCAL/ADXO calendar. Check the bands and modes to plan hunting a new DXCC.',
    'dxped.sourceUnavailable': 'The DXpedition source is temporarily unavailable.',
    'dxped.qsl': 'QSL:',
    'dxped.qrv': 'QRV',
    'dxped.errLoad': 'Could not load the DXpedition list',
    'trash.title': 'Trash',
    'trash.errLoad': 'Could not load the trash',
    'trash.errGeneric': 'Error',
    'trash.restoredMsg': 'Restored',
    'trash.purgedMsg': 'Permanently deleted',
    'trash.selectedQso': 'selected QSOs',
    'trash.wholeBin': 'the ENTIRE trash',
    'trash.confirmPurgePre': 'Permanently delete',
    'trash.confirmPurgePost': '?\n\nThis operation CANNOT be undone — the contacts will be gone forever.',
    'trash.descPre': 'Deleted contacts wait here for',
    'trash.descPost': 'before being gone for good. They do not count toward stats, awards, or ADIF export — they return to the log only once restored.',
    'trash.restoreBtn': '♻️ Restore',
    'trash.purgeBtn': 'Delete permanently',
    'trash.deselect': 'Deselect',
    'trash.emptyPre': 'The trash is empty. Deleted QSOs will appear here and wait',
    'trash.emptyPost': 'for possible restoration.',
    'trash.colDeleted': 'Deleted',
    'trash.colExpiresIn': 'Expires in',
    'trash.daysUnit': 'days',
    'trash.emptyBin': 'Empty the entire trash',
    'mw.title': 'Most Wanted DXCC',
    'mw.desc': 'Ranking of the most wanted DXCC entities according to Club Log.',
    'dxccmap.title': 'My DXCC map',
    'dxccmap.worked': 'Worked countries',
    'dxccmap.missingMw': 'Most wanted entities you are missing',
    'dxccmap.errLoad': 'Could not load the DXCC map',
    'dxccmap.mwListNote': 'List based on the Most Wanted ranking — these entities are especially worth hunting.',
    'dxccmap.showLess': 'Show less',
    'dxccmap.showAll': 'Show all',
    'dxccmap.unmappedTitle': 'Unrecognized country names',
    'dxccmap.unmappedNote': 'These QSOs were not counted toward DXCC — check whether the country name is correct.',
    'dxneeded.title': 'Needed hunter (DX)',
    'dxneeded.onlyNeeded': 'Needed only',
    'dxneeded.descPre': "DX Cluster spots whose",
    'dxneeded.prefixWord': 'prefix',
    'dxneeded.descPost': "you don't have yet in your log — potentially worth calling. This is a signal based on the WPX prefix, not a strict guarantee of a new DXCC.",
    'dxneeded.errLoad': 'Could not load the spots',
    'dxneeded.all': 'All',
    'dxneeded.emptyNeeded': 'No new prefixes among the current spots. You already have them all! 🎉 (or the cluster is quiet)',
    'dxneeded.emptyAll': 'No spots. The DX Cluster may still be connecting — check the "DX Cluster" tab.',
    'dxneeded.prefix': 'prefix',
    'dxneeded.logQsoTitle': 'Log a QSO with this station',
    'dxneeded.footer1': 'You have',
    'dxneeded.footer2': 'prefixes in your log · refreshing every 30s · spots from the same source as "DX Cluster"',
    'wwff.title': 'WWFF — Flora & Fauna',
    'activity.title': 'Activity',
    'activity.longestStreak': 'Longest streak (days)',
    'activity.currentStreak': 'Current streak (days)',
    'activity.activeDays': 'Days with QSOs',
    'activity.avgPerDay': 'Average QSOs / day',
    'activity.bestDay': 'Best day',
    'activity.byYear': 'QSOs by year',
    // Logger -- form (full)
    'logger.callsignReq': 'Callsign *',
    'logger.dateTimeUtc': 'Date/Time UTC',
    'logger.modeReq': 'Mode *',
    'logger.freqReq': 'Frequency (MHz) *',
    'logger.nameSurname': 'Name and surname',
    'logger.gridLoc': 'Grid locator',
    'logger.dxcc': 'DXCC',
    'logger.iota': 'IOTA',
    'logger.usState': 'State (USA)',
    'logger.cqZone': 'CQ zone',
    'logger.qslSent': 'QSL sent',
    'logger.qslRecv': 'QSL received',
    // Auth
    'auth.callsign': 'Callsign',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.newPassword': 'New password',
    'auth.repeatPassword': 'Repeat new password',
    'auth.login': 'Log in',
    'auth.register': 'Sign up',
    'auth.confirmCode': 'Confirm code',
    'auth.sendResetLink': 'Send reset link',
    'auth.totpHint': 'Enter the code from your authenticator app. No phone? Use one of your backup codes.',
    // Radio
    'radio.model': 'Radio model',
    'radio.connType': 'Connection type',
    'radio.serialPort': 'Serial port',
    // LiveViews
    'pota.title': 'POTA / SOTA',
    'psk.title': 'PSK Reporter — Where your signal was heard',
    'sat.title': 'Amateur satellites — upcoming passes',
    'websdr.title': 'WebSDR — check if you are getting out',
    'svx.title': 'SVXLink — live talkgroup monitor',
    'pota.spots': 'Active spots',
    'pota.myStats': 'My statistics',
    'pota.park': 'Park',
    // Community
    'diplomas.title': 'Award events',
    'neighbors.title': 'Neighbour finder',
    'shared.title': 'Shared logbook (multi-operator)',
    'diplomas.sync': 'Sync now',
    'diplomas.activeNow': 'Active now',
    // Tools
    'weather.title': 'Weather',
    'eqsl.title': 'eQSL designer',
    'eqsl.accentColor': 'Accent colour',
    'eqsl.textColor': 'Text colour',
    'eqsl.clubName': 'Club name (optional)',
    'eqsl.slogan': 'Slogan / caption',
    // Remaining views
    'contest.title': 'Contest mode',
    'watchlist.title': 'DX Watchlist — Telegram + Discord alerts',
    'logbook.header': 'Logbook',
    'qsomap.title': 'QSO map',
    'cluster.title': 'DX Cluster',
    // Notify messages -- most common
    'notify.qsoSaved': 'QSO saved to the log!',
    'notify.qsoUpdated': 'QSO updated',
    'notify.qsoDeleted': 'QSO deleted',
    'notify.saveError': 'Save error',
    'notify.loadError': 'Error loading data',
    'notify.badFreq': 'Enter a valid frequency',
    'notify.radioSaved': 'Radio configuration saved',
    'notify.qsyError': 'Error sending QSY command',
    'notify.exported': 'Exported',
    'notify.imported': 'Imported',
    'notify.copied': 'Copied',
    // Admin -- full
    'admin.newAnnouncement': 'New announcement',
    'admin.title': 'Title',
    'admin.body': 'Body',
    'admin.bodyPlaceholder': 'Message details...',
    'admin.level': 'Level',
    'admin.levelInfo': 'ℹ️ Information',
    'admin.levelWarning': '⚠️ Warning',
    'admin.levelCritical': '🚨 Critical (cannot be dismissed)',
    'admin.expires': 'Expires (optional)',
    'admin.publish': '📢 Publish',
    'admin.published': 'Published',
    'admin.noAnnouncements': 'No announcements',
    'admin.deleted': '(deleted)',
    'admin.expired': '(expired)',
    'admin.actionDeleteUser': '🗑️ Account deletion',
    'admin.actionUpdateUser': '✏️ Permission/status change',
    'admin.actionResetPassword': '🔑 Password reset',
    'admin.actionImpersonate': '🎭 Logged in as user',
    'admin.actionUpdateSettings': '⚙️ System settings change',
    'admin.actionUpdateQso': "✏️ Edited another user's QSO",
    'admin.actionDeleteQso': "🗑️ Deleted another user's QSO",
    'admin.errLoadAnnouncements': 'Could not load announcements',
    'admin.titleBodyRequired': 'Title and body are required',
    'admin.titlePlaceholder': 'e.g. Planned server restart',
    'admin.announcementPublished': 'Announcement published',
    'admin.errPublish': 'Publish error',
    'admin.errGeneric': 'Error',
    'admin.confirmDeleteAnnouncement': 'Permanently delete the announcement',
    'admin.itemDeleted': 'Deleted',
    'admin.announcementNote': 'All logged-in users will see the announcement in the banner at the top of the app. The "critical" level cannot be dismissed by the user. The announcement disappears on its own after the expiration date.',
    'admin.expiresAt': 'expires',
    'admin.disabled': '(disabled)',
    'admin.deletePermanently': 'Delete permanently',
    'admin.enable': '✅ Enable',
    'admin.disable': '⛔ Disable',
    'admin.details': 'Details',
    'admin.whoAffected': 'Affected',
    'admin.testFeatures': 'Beta features',
    'admin.noTestFeatures': 'No beta features.',
    'admin.repeaterDb': '📡 Repeater database',
    'admin.svxGroups': '🎙️ SVXLink talkgroups',
    'admin.addGroup': '+ Add group',
    'admin.clearLog': 'Clear log',
    'admin.next': 'Next →',
    'admin.retry': 'Try again',
    'admin.noBackup': 'No data -- backup has not run yet',
    'admin.termsContent': 'Terms content (markdown)',
    'admin.adminName': 'Administrator name / callsign',
    'admin.threshold': 'Threshold (failed attempts in 10 min):',
    'admin.sentByMail': 'Sent by email to',
    'admin.errFeatureFlags404': 'Endpoint does not exist on the server (404). Build and deploy the backend: sudo docker compose build --no-cache backend && sudo docker compose up -d',
    'admin.errFeatureFlagsLoad': 'Error loading test features',
    'admin.featureEnabledAll': 'enabled',
    'admin.featureDisabledAll': 'disabled',
    'admin.featureToggled': 'Feature',
    'admin.featureToggledSuffix': 'for everyone',
    'admin.errToggleFlag': 'Error changing the flag',
    'admin.logCleared': 'Log cleared',
    'admin.repeatersImported': 'Imported',
    'admin.repeatersUnit': 'repeaters',
    'admin.errImport': 'Import error',
    'admin.saved': 'Saved',
    'admin.altCallsignsPromptTitle': 'Special-event callsigns for',
    'admin.altCallsignsPromptBody': 'Separate with commas, e.g.: SN0HQ, HF100PL\nLeave empty to revoke all.\n\nNote: QSOs already logged under a revoked callsign will REMAIN in the log.',
    'admin.altCallsignsGranted': 'granted callsigns',
    'admin.altCallsignsRevoked': 'revoked special-event callsigns',
    'admin.errGrantCallsigns': 'Error granting callsigns',
    'admin.roleUser': 'User',
    'admin.roleModerator': 'Moderator',
    'admin.roleAdmin': 'Administrator',
    'admin.confirmGrantRole': 'Grant user',
    'admin.roleColon': 'the role:',
    'admin.roleAdminDetail': 'Administrator has FULL access: deleting accounts, system settings, backups, impersonation.',
    'admin.roleModeratorDetail': 'Moderator can view the panel and suspend accounts, but CANNOT grant permissions or delete accounts.',
    'admin.roleChanged': 'Role',
    'admin.errChangeRole': 'Error changing role',
    'admin.confirmDeleteAccount': 'Delete the account',
    'admin.confirmDeleteAccountSuffix': 'along with its entire log? This operation cannot be undone.',
    'admin.accountDeletedSuffix': 'deleted',
    'admin.confirmImpersonate': 'Log in as',
    'admin.confirmImpersonateSuffix': '? Your own session will be preserved -- you will be able to switch back easily.',
    'admin.errImpersonate': 'Error switching account',
    'admin.loadingPanel': '⏳ Loading admin panel...',
    'admin.panelTitle': 'Admin Panel',
    'admin.systemStatusHeading': '🩺 System status',
    'admin.testFeaturesTab': 'Test features',
    'admin.systemStatusTab': 'System status',
    'admin.moderatorModeTitle': 'Moderator mode.',
    'admin.moderatorModeDesc1': 'You can view statistics, the user list, and the activity log, as well as',
    'admin.moderatorModeDesc2': 'suspend/unsuspend regular accounts',
    'admin.moderatorModeDesc3': 'Granting permissions, deleting accounts, system settings, and backups are reserved for the administrator.',
    'admin.statUsers': 'Users',
    'admin.statQsos': 'Contacts (all)',
    'admin.statVerified': 'Email verified',
    'admin.statPublicProfiles': 'Public profiles',
    'admin.statSuspended': 'Suspended accounts',
    'admin.statSharedLogs': 'Shared logbooks',
    'admin.smtpLabel': 'SMTP',
    'admin.smtpConfigured': '✅ Configured',
    'admin.smtpNotConfigured': '⚠️ Not configured',
    'admin.telegramLabel': 'Telegram Bot',
    'admin.telegramConfigured': '✅ Configured',
    'admin.telegramNotConfigured': '⚠️ Not configured',
    'admin.clusterCacheLabel': 'DX Cluster cache',
    'admin.spotsUnit': 'spots',
    'admin.secondsAgo': 's ago',
    'admin.lastDiplomaSync': 'Last award sync',
    'admin.neverYet': 'not yet',
    'admin.recentRegistrations': 'Recent registrations',
    'admin.colCallsign': 'Callsign',
    'admin.colEmail': 'Email',
    'admin.colDate': 'Date',
    'admin.colEmailVerified': 'Email verified',
    'admin.colQso': 'QSO',
    'admin.colLastLogin': 'Last login',
    'admin.colVerified': 'Verified',
    'admin.never': 'never',
    'admin.today': 'today',
    'admin.yesterday': 'yesterday',
    'admin.daysAgo': 'days ago',
    'admin.cannotChangeOwnRole': 'You cannot change your own admin role',
    'admin.changeRoleTitle': 'Change role',
    'admin.resetPasswordBtn': 'Reset password',
    'admin.editAccountBtn': 'Account details',
    'admin.editAccountTitle': 'Fix email/callsign/home location',
    'admin.qsoManageBtn': 'QSO',
    'admin.qsoManageTitle': "Review/edit this user's QSOs",
    'admin.altCallsignsBtn': 'Callsigns',
    'admin.altCallsignsTitle': 'Grant/revoke special-event callsigns (SN0HQ, HF100PL...)',
    'admin.impersonateBtn': '🎭 Log in as',
    'admin.impersonateTitle': 'Log in as this user (e.g. a special-event station)',
    'admin.ffDescPre': 'The features below are visible to',
    'admin.ffDescAdminsAlways': 'administrators always',
    'admin.ffDescMid': '(you can test them right away). The switch decides whether the feature is also visible to',
    'admin.ffDescPost': 'Enable only once the feature is ready.',
    'admin.ffDescYoutuber': 'Users in the 🎥 Youtuber group (see the column in the table below) also see all test features right away, same as admins -- regardless of their role. This is an additional, separate group (it does not replace the user/moderator/admin roles), useful so someone can show a new feature in a video before it reaches everyone.',
    'admin.colYoutuber': '🎥 Youtuber',
    'admin.youtuberColTitle': 'Additional group with early access to test features (independent of role)',
    'admin.youtuberCheckboxTitle': 'Youtuber -- early access to test features, same as admin (no other permissions)',
    'admin.featureVisibleAll': '● visible to everyone',
    'admin.featureAdminOnly': '○ admins only',
    'admin.idLabel': 'id:',
    'admin.backupsDescA': 'Backups are made automatically by a separate background service (cron, according to the schedule',
    'admin.backupsDescB': 'from',
    'admin.backupsDescC': ', daily at 3:00 by default) -- this list is purely informational. Files are kept for',
    'admin.backupsDescD': 'days (14 by default), older ones are automatically deleted.',
    'admin.refreshList': '↻ Refresh list',
    'admin.colFile': 'File',
    'admin.colSize': 'Size',
    'admin.colCreated': 'Created',
    'admin.restoreBtn': '♻️ Restore',
    'admin.restoreTitle': 'Restore the database from this file -- overwrites current data',
    'admin.noBackupsYet': 'No backups (the first will be made automatically shortly after the "backup" service starts)',
    'admin.manualRestoreDesc': 'Manual restore from the command line (alternative to the "♻️ Restore" button above, in case e.g. the backend is temporarily unavailable):',
    'admin.repeaterDbDescA': 'Repeater data (the "📡 Repeaters" tab in the Logger) is stored locally in the database, NOT queried live from przemienniki.eu. To update, download a fresh JSON export from',
    'admin.repeaterDbDescB': 'and upload it below (this replaces the entire current database).',
    'admin.repeatersInDb': 'In the database:',
    'admin.lastImport': 'last import:',
    'admin.importingRepeaters': '⏳ Importing...',
    'admin.uploadJsonExport': 'Upload JSON export',
    'admin.loadingGeneric': '⏳ Loading...',
    'admin.statusPageDesc': 'The state of the installation in one place -- instead of discovering a problem only once something breaks for a user. External service status is checked live (every time this tab is opened).',
    'admin.backupDbTitle': '💾 Database backup',
    'admin.statusOk': '✓ OK',
    'admin.statusError': '✗ ERROR',
    'admin.smtpEmailTitle': '✉️ SMTP (email)',
    'admin.notConfigured': 'Not configured',
    'admin.smtpWorks': '✓ Working',
    'admin.smtpLastSendError': '✗ Error on last send',
    'admin.noData': 'No data',
    'admin.securityLabel': 'Security:',
    'admin.hamqslTitle': '🌍 hamqsl.com (propagation)',
    'admin.available': '✓ Available',
    'admin.unavailable': '✗ Unavailable',
    'admin.qrzTitle': '📇 QRZ.com',
    'admin.dbTitle': '📊 Database',
    'admin.dbActiveUsers': 'active /',
    'admin.dbTotalUsers': 'accounts total',
    'admin.activityLogDesc': "Sensitive admin actions -- deleting an account, resetting someone's password, logging in as another user, changing permissions/suspending an account, changing system settings. Not a full audit (does not log data browsing), just basic accountability.",
    'admin.noActionsLogged': 'No recorded actions',
    'admin.colWhen': 'When',
    'admin.colAdmin': 'Admin',
    'admin.colAction': 'Action',
    'admin.prevPage': '← Previous',
    'admin.pageLabel': 'Page',
    'admin.debugDescA': 'Diagnostic logs from the WebSDR tab (for every user) -- enable/disable collection in the "Settings" tab. One of the possible (but NOT guaranteed) causes of "doesn\'t always load": a receiver over',
    'admin.debugDescB': 'embedded on a page over',
    'admin.debugDescC': 'may get blocked by the browser without any error message ("mixed content") -- but behavior differs between browsers. A',
    'admin.debugDescD': 'entry in the "Details" column mentions http:// if that applied to this receiver.',
    'admin.colTime': 'Time',
    'admin.colEvent': 'Event',
    'admin.colReceiver': 'Receiver',
    'admin.colFreqMode': 'Freq/Mode',
    'admin.noDebugEntries': 'No entries',
    'admin.debugCollectionOff': '-- or log collection is disabled in Settings',
    'common.refreshBtn': '↻ Refresh',
    // App -- remaining
    'bulk.changeBand': 'Change band to...',
    'bulk.changeMode': 'Change mode to...',
    'bulk.applyBand': 'Apply band',
    'bulk.applyMode': 'Apply mode',
    'bulk.deleteSelected': 'Delete selected',
    'bulk.qslToSend': '📇 QSL to send',
    'bulk.applyStation': 'Apply callsign',
    'common.loadingDots': '⏳ Loading...',
    'common.refreshNow': '↻ Refresh now',
    'common.back': '← Back',
    'common.qsos': 'QSOs',
    'common.details': 'Details',
    'common.later': 'Later',
    'common.available': 'Available:',
    'contest.exchangeSent': 'Exchange sent (e.g. 599 001)',
    'contest.name': 'Contest name',
    'contest.backToLogger': '↩ Back to the normal logger',
    'cluster.connecting': '⏳ Connecting to the DX cluster stream...',
    'eqsl.sendNow': '✓ Send now',
    'eqsl.send': '📧 Send eQSL',
    'eqsl.toSend': '⏳ To send',
    'eqsl.sent': '📤 Sent',
    'newVersion': '🔄 A new version of HamLogger is available — refresh to load it.',
    'lang.label': 'Language / Język',
    // Antenna calculator
    'ant.plotConditions': 'Plot conditions',
    'ant.maxHeight': 'Max height (m)',
    'ant.maxHorizontal': 'Max horizontal length (m)',
    'ant.canBuryRadials': 'I can bury radials',
    'ant.setConditions': 'Set the plot conditions and click "Calculate antennas".',
    'ant.noResults': 'No results for the selected bands.',
    'ant.showViz': 'Show visualisation',
    'ant.selectForViz': 'Select an antenna in the "Results" tab to see the visualisation.',
    'ant.freqMhz': 'Frequency (MHz)',
    'ant.lengthM': 'Length (m)',
    'ant.wireDiameter': 'Wire diameter (mm)',
    'ant.electricalLength': 'Electrical length',
    'ant.peakVoltage': 'Peak voltage',
    'ant.efficiency': 'Efficiency',
    'ant.totalLoss': 'Total loss',
    'ant.searchAddress': 'Search address / town...',
    'ant.clickMapTerrain': 'Click on the map to check the terrain height at that point.',

    'pathcalc.title': 'DX Path Calculator',
    'pathcalc.desc': 'Enter the locator of the station you want to work -- I\'ll calculate distance, bearing (short and long path) from your QTH, and check the time of day on both ends. Useful before calling CQ on the low bands: grayline on either end usually means better DX conditions.',
    'pathcalc.targetGrid': 'Target locator (e.g. FN20, JO91)',
    'pathcalc.targetPlaceholder': 'e.g. KN18',
    'pathcalc.calculate': 'Calculate',
    'pathcalc.errEmpty': 'Enter a locator (e.g. FN20 for the eastern US).',
    'pathcalc.errInvalidGrid': 'Invalid Maidenhead locator.',
    'pathcalc.errUnreadable': 'Could not read the locator.',
    'pathcalc.distance': 'Distance',
    'pathcalc.miles': 'miles',
    'pathcalc.bearingShort': 'Bearing (short path)',
    'pathcalc.bearingLong': 'Bearing (long path)',
    'pathcalc.yourQth': '🏠 Your QTH',
    'pathcalc.day': 'Day',
    'pathcalc.night': 'Night',
    'pathcalc.grayline': 'Grayline (dawn/dusk)',
    'pathcalc.greylineTip': '💡 At least one end of the path is in the grayline/night zone -- a good time to try DX on 160/80/40m.',

    'qsorate.title': 'QSO Rate Meter',
    'qsorate.hours12': '12 hours',
    'qsorate.hours24': '24 hours',
    'qsorate.hours48': '48 hours',
    'qsorate.hours72': '72 hours',
    'qsorate.desc': 'QSOs per hour from your log -- refreshes automatically every minute. Useful during contests or activations to see at a glance whether your rate is climbing.',
    'qsorate.last60min': 'QSOs (last 60 min)',
    'qsorate.total': 'Total',
    'qsorate.bestHour': 'Best hour',
    'qsorate.now': 'now',
    'qsorate.errLoad': 'Could not load QSO rate',

    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Welcome',
    'dashboard.quickOverview': 'a quick overview of your log and the airwaves.',
    'dashboard.totalQsos': 'Total QSOs',
    'dashboard.uniqueCallsigns': 'Unique callsigns',
    'dashboard.countriesDxcc': 'Countries (DXCC)',
    'dashboard.newQso': '📻 New QSO',
    'dashboard.recentQsos': 'Recent QSOs',
    'dashboard.noQsos': 'No QSOs in your log yet -- log your first one.',
    'dashboard.dateTime': 'Date/Time',

    'roster.title': 'Live Roster',
    'roster.connected': '● connected',
    'roster.connecting': '○ connecting...',
    'roster.desc': 'Every station WSJT-X decodes in real time (not just logged QSOs) -- updates itself. Requires an updated agent (download it again from the Radio widget if the list stays empty despite WSJT-X running).',
    'roster.filterPlaceholder': '🔍 Filter by callsign...',
    'roster.onlyNew': 'Only new (not worked yet)',
    'roster.stationCount': 'stations',
    'roster.noDataAtAll': 'No data -- make sure the WSJT-X agent is running and you have the latest version (Radio widget -> download again).',
    'roster.noDataFiltered': 'No stations match the filter.',
    'roster.snr': 'SNR',
    'roster.grid': 'Grid',
    'roster.isCq': 'CQ?',
    'roster.lastHeard': 'Last heard',
    'roster.status': 'Status',
    'roster.alreadyWorked': 'already worked',
    'roster.new': '✨ new',
    'roster.loadToLogger': 'To logger',
    'roster.errLoad': 'Could not load the roster',
    'roster.secondsAgo': 's ago',
    'roster.minutesAgo': 'min ago',

    'grayline.title': 'Grayline map (terminator)',
    'grayline.errLoad': 'Could not load grayline data',
    'grayline.desc': 'The terminator line (dawn/dusk) is a zone of exceptional DX propagation on the low bands (160/80/40m). Stations near this line have the best chance of a grayline contact right now. The map refreshes automatically every 5 minutes.',
    'grayline.subsolarTooltip': '☀️ Subsolar point (Sun at zenith)',
    'grayline.subsolarPoint': '☀️ Subsolar point:',
    'grayline.sunDeclination': 'Sun declination:',
    'grayline.serverCalc': 'Server-side calculation',

    'onthisday.label': 'On this day',
    'onthisday.qsoUnit': 'QSOs',
    'onthisday.inPreposition': 'across',
    'onthisday.year': 'year',
    'onthisday.years': 'years',
    'onthisday.yearAgo': 'A year ago',
    'onthisday.yearsAgoSuffix': 'years ago',
    'onthisday.andMorePrefix': '...and',
    'onthisday.andMoreSuffix': 'more',

    'maps.graylineOn': 'ON',
    'maps.graylineOff': 'OFF',
    'maps.yourPosition': 'Your position',
    'maps.qsoInArea': 'QSOs in this area',
    'maps.andMorePrefix': '... and',
    'maps.andMoreSuffix': 'more',
    'maps.locatorGridTitle': 'Location & Locator Grid',
    'maps.you': 'You',
    'maps.lookupHint': 'Enter a callsign and run a QRZ lookup (or enter the locator manually) to see the other station\'s position and distance',

    'prop.sfiExcellent': 'Excellent — higher bands (10/12/15m) open',
    'prop.sfiGood': 'Good — higher bands active',
    'prop.sfiModerate': 'Moderate — mainly mid bands',
    'prop.sfiWeak': 'Weak — lower bands (40/80m)',
    'prop.sfiVeryWeak': 'Very weak — tough HF conditions',
    'prop.kQuiet': 'Quiet — very good conditions',
    'prop.kUnsettled': 'Unsettled — conditions OK',
    'prop.kActive': 'Active — possible disturbances',
    'prop.kStorm': 'Geomagnetic storm — HF degraded',
    'prop.kSevereStorm': 'Severe storm — HF heavily disturbed',
    'prop.xrayExtreme': 'Extreme X-class flare',
    'prop.xrayStrong': 'Strong M-class flare',
    'prop.xrayModerate': 'Moderate C-class flare',
    'prop.xrayQuiet': 'Quiet (A/B background)',
    'prop.errSource': 'Propagation source temporarily unavailable (hamqsl.com)',
    'prop.errLoad': 'Could not load propagation data',
    'prop.title': 'HF/VHF propagation — space weather',
    'prop.updated': 'Updated:',
    'prop.source': '· source: hamqsl.com (N0NBH)',
    'prop.alertXray': 'possible HF blackouts on the daylight side of Earth',
    'prop.alertAuroraPrefix': 'High aurora activity (level',
    'prop.alertAuroraSuffix': ') — HF degraded at high latitudes, possible aurora propagation on VHF',
    'prop.sfiLabel': 'SFI (Solar Flux)',
    'prop.aIndex': 'A-index',
    'prop.aIndexHint': 'Geomagnetic activity (daily)',
    'prop.solarWindHint': 'Plasma speed',
    'prop.kIndex': 'K-index',
    'prop.aurora': 'Aurora',
    'prop.auroraActiveHint': 'Active — affecting propagation',
    'prop.quiet': 'Quiet',
    'prop.bzField': 'Bz (mag. field)',
    'prop.bzSouthHint': 'Pointing south — may intensify storms',
    'prop.bzCalmHint': 'Relatively calm',
    'prop.geomagField': 'Geomagnetic field',
    'prop.signalNoise': 'Band noise (S)',
    'prop.signalNoiseHint': 'Background noise level',
    'prop.mufHint': 'Maximum usable frequency',
    'prop.fof2Hint': 'F2 critical frequency',
    'prop.hfConditions': 'HF band conditions',
    'prop.band': 'Band',
    'prop.night': 'Night',
    'prop.vhfConditions': 'VHF conditions',
    'prop.heliumLine': 'Helium line 304Å:',
    'prop.banners': 'Propagation graphics (hamqsl.com)',
    'prop.bannerSolar': 'Solar conditions and bands',
    'prop.bannerMuf': 'MUF and foF2',
    'prop.bannerVhf': 'VHF conditions',
    'prop.bannerNote': 'Graphics generated live by hamqsl.com (N0NBH). If they don\'t load, the service may be temporarily unavailable.',
    'prop.sunAlt': 'Sun SDO AIA 193',
    'prop.sunNote': 'Solar Dynamics Observatory (NASA), AIA 193Å channel -- shows the solar corona and active regions. Brighter areas are flare sources.',

    'weather.errLoad': 'Could not load weather data',
    'weather.source': 'Weather: Open-Meteo · Warnings: IMGW-PIB · location from profile',
    'weather.refresh': '↻ Refresh',
    'weather.imgwOfficial': 'Official IMGW warning',
    'weather.forecastWarning': 'Warning (forecast)',
    'weather.degree': 'Level',
    'weather.probability': 'probability',
    'weather.validFrom': 'valid',
    'weather.openMeteoForecast': 'Open-Meteo forecast (no active official IMGW warning for this location/region)',
    'weather.stormAdvice': 'Consider disconnecting the antenna from the radio during the storm -- a lightning strike can damage equipment and poses a real risk (including fire/electrical).',
    'weather.noStorm': '✅ No storm in the next 6h forecast',
    'weather.now': 'Now',
    'weather.wind': 'Wind',
    'weather.windSpeed': 'speed',
    'weather.gusts': 'Gusts',
    'weather.maxGust': 'max gust',
    'weather.humidity': 'Humidity',
    'weather.precipitation': 'Precipitation',
    'weather.current': 'current',
    'weather.hourlyForecast': 'Hourly forecast (24h)',
    'weather.noData': 'No weather data',
    'weather.imgwMaps': '🗺️ IMGW Maps',
    'weather.imgwMapsDesc': 'IMGW maps are rendered dynamically (tiles) -- they open on their site in a new tab, instead of a "hardcoded" embedded image that could stop working with every change to their service.',
    'weather.mapWarnings': 'Warnings map',
    'weather.mapWarningsDesc': 'active weather/hydro alerts',
    'weather.mapRadar': 'Precipitation radar',
    'weather.mapRadarDesc': 'live precipitation',
    'weather.mapSatellite': 'Satellite images',
    'weather.mapSatelliteDesc': 'cloud cover',
    'weather.mapLightning': 'Lightning',
    'weather.mapLightningDesc': 'density/location',
    'weather.credit': 'Warning data sourced from the Institute of Meteorology and Water Management -- National Research Institute (IMGW-PIB). Weather data: Open-Meteo (open-source).',

    'eqsl.saveTemplate': '✓ Save template',
    'eqsl.bgColor': 'Background color',
    'eqsl.bgColorHint': '(used only when you remove your custom background below)',
    'eqsl.clubNamePlaceholder': 'e.g. SP3PWR Club',
    'eqsl.borderWidth': 'Border width',
    'eqsl.showWatermark': 'Show the "Generated with HamLogger" footer on the card',
    'eqsl.langMode': 'Card and email language',
    'eqsl.langAuto': 'Automatic (by recipient callsign prefix)',
    'eqsl.langAlwaysPl': 'Always Polish',
    'eqsl.langAlwaysEn': 'Always English',
    'eqsl.langModeDesc': '"Automatic" sends cards/emails in Polish to SP/SQ/SO callsigns, in English to everyone else. Pick a fixed language if you always want one version.',
    'eqsl.dragFieldsDesc': 'Drag any field on the preview to the right to change its position -- especially useful with a custom background (every QSL card has fields in a different spot and size). Click a field in the list to set its font size precisely.',
    'eqsl.fieldX': 'X',
    'eqsl.fieldY': 'Y',
    'eqsl.fieldSize': 'Size',
    'eqsl.autoSendDesc': 'This card is automatically emailed to the other station (to the address found on QRZ, if they made it public) -- by checking the "Send eQSL" checkbox in the logger form, or manually from the button in the Logbook. You set the checkbox\'s default state in account settings (click your callsign in the top right).',
    'eqsl.livePreview': 'Live preview',
    'eqsl.dragFields': 'drag the fields',
    'eqsl.previewPl': 'Preview the Polish version',
    'eqsl.previewEn': 'Preview the English version',
    'eqsl.previewAlt': 'eQSL card preview',
    'eqsl.loadingPreview': 'Loading preview...',
    'eqsl.customBgTitle': 'Custom background',
    'eqsl.customBgDesc': 'If you already have your own designed QSL card (e.g. made in another graphics program), you can upload it here as a background -- QSO data (callsign, date, band, RST...) is drawn ON TOP of it, at the positions you set above (by dragging on the preview). Without a custom background, a solid color from the settings on the left is used.',
    'eqsl.customBgAlt': 'Custom eQSL background',
    'eqsl.uploading': 'Uploading...',
    'eqsl.changeBg': 'Change background',
    'eqsl.uploadBg': 'Upload background',
    'eqsl.formatsInfo': 'Supported formats: JPG, PNG, GIF, WEBP. Max 3MB. An image with different proportions than the card (900×560) is automatically cropped to fill the frame (without distortion), like a CSS background -- if important details are right at the edges, they may get cropped.',
    'eqsl.savedNotify': 'eQSL template saved!',
    'eqsl.errSaveTemplate': 'Error saving template',
    'eqsl.bgSavedNotify': 'eQSL background saved -- drag the fields on the preview to arrange them like on your card',
    'eqsl.errUploadImage': 'Error uploading the image',
    'eqsl.confirmRemoveBg': 'Remove the custom background? You\'ll go back to a solid background color.',
    'eqsl.bgRemovedNotify': 'Custom background removed -- back to a solid background color',
    'eqsl.errRemoveImage': 'Error removing the image',
    'eqsl.confirmResetPositions': 'Reset all fields to their default positions?',
    'eqsl.loadingEditor': '⏳ Loading editor...',
    'eqsl.fieldSenderCallsign': 'Callsign (yours)',
    'eqsl.fieldRecipientCallsign': 'Callsign (other station)',
    'eqsl.fieldDate': 'Date',
    'eqsl.fieldTime': 'Time',
    'eqsl.fieldBand': 'Band',
    'eqsl.fieldMode': 'Mode',
    'eqsl.fieldRstSent': 'RST sent',
    'eqsl.fieldRstRecv': 'RST rcvd',
    'eqsl.fieldClubName': 'Club',
    'eqsl.fieldSlogan': 'Slogan',
    // Propagation dashboard
    'prop.sunImage': 'Current image of the Sun (SDO / NASA)',
    'prop.sunUnavailable': 'Solar image temporarily unavailable',
    'prop.details': 'Detailed data',
    'prop.sunspots': 'Sunspots (SN)',
    'prop.xray': 'Flares (X-ray)',
    'prop.solarWind': 'Solar wind',
    'prop.protonFlux': 'Proton flux:',
    'prop.electronFlux': 'Electron flux:',
    'prop.day': 'Day',
    // Satellites
    'sat.yourLat': 'Your latitude (lat)',
    'sat.yourLon': 'Your longitude (lon)',
    'sat.altitude': 'Altitude ASL (m, optional)',
    'sat.enterCoords': 'Enter your coordinates, pick a satellite and click "Track".',
    'sat.belowHorizon': 'Below the horizon — no pass in the next 24h',
    'sat.distance': 'Distance',
    'sat.groundTrack': 'Ground track',
    'sat.backToList': '← Back to the list',
    // LiveViews -- full
    'live.noPasses': 'No upcoming passes in the next 48h',
    'live.noReceivers': 'No saved receivers — click "⚙️ Manage list"',
    'live.noGroups': 'No talkgroups configured — an administrator can add them in the Admin panel',
    'live.manageList': 'Manage list',
    'live.openNewTab': '↗ Open in a new tab',
    'live.receiverName': 'Name (e.g. SP3RC Zielona Gora)',
    'live.giveNameUrl': 'Enter the receiver name and URL',
    'live.saveError': 'Error saving the receiver list',
    'live.rise': 'Rise',
    'live.set': 'Set',
    'live.aimAntenna': 'Click to aim the antenna at this satellite',
    'live.aimHint': '🎯 Click to aim the antenna →',
    'live.noCatAgent': 'No CAT agent — enter the frequency manually',
    'live.playingBg': '🔊 Playback continues in the background',
    // Admin -- rest
    'admin.workingAs': '📻 Operating as',
    'admin.altCallsigns': '⚙️ Special event callsigns',
    'admin.altCallsignsHint': 'Special event callsigns (comma separated), e.g.',
    'admin.alsoAdifLotw': '— also in ADIF/LoTW',
    'admin.svxGroupsTab': '🎙️ SVXLink talkgroups ("Live" tab)',
    'admin.giveNameUrlStream': 'Enter the stream name and URL',
    'admin.groupSaveError': 'Error saving the talkgroup list',
    'admin.clearLogError': 'Error clearing the log',
    'admin.groupsSaved': 'SVXLink talkgroup list saved',
    'admin.settingsSaved': 'Settings saved',
    'admin.errSaveSettings': 'Error saving settings',
    'admin.giveTestEmail': 'Enter an email address to test',
    'admin.testEmailSent': 'Test email sent!',
    'admin.testEmailFailed': 'Sending failed',
    'admin.errTestEmail': 'Error sending the test',
    'admin.smtpHeading': '📧 SMTP configuration (password reset, email verification)',
    'admin.imapHeading': '📥 Copy of sent mail in IMAP (Sent folder)',
    'admin.notificationsHeading': '📨 System notifications',
    'admin.securityHeading': '🔐 Registration and security',
    'admin.loggerDefaultsHeading': '📻 Default logger settings (for new accounts)',
    'admin.inactivityHeading': '📧 Inactivity reminder',
    'admin.maintenanceHeading': '🔧 Maintenance mode',
    'admin.debugWebsdrHeading': '🐛 WebSDR debug',
    'admin.adminNotifHeading': '🔔 Administrator notifications (by email)',
    'admin.systemFeaturesHeading': '🧩 System features',
    'admin.termsHeading': '📜 Terms and contact',
    'admin.otherSettingsHeading': '⚙️ Other settings',
    'admin.smtpHost': 'SMTP host',
    'admin.port': 'Port',
    'admin.connectionSecurity': 'Connection security',
    'admin.smtpUser': 'SMTP user',
    'admin.smtpPassword': 'SMTP password',
    'admin.valueSet': '(set)',
    'admin.fromAddress': '"From" address',
    'admin.enterToChange': 'Enter to change',
    'admin.smtpSecurityNote': 'These are three different, incompatible methods -- a server usually supports only one. "STARTTLS extension not supported" error -- switch to SSL/TLS (and port 465), or, if this is your own server on a local network with no TLS at all, to "None".',
    'admin.startTls587': 'STARTTLS (typically port 587)',
    'admin.ssl465': 'SSL/TLS (typically port 465)',
    'admin.noneLan': 'None (no encryption -- e.g. your own server on a LAN)',
    'admin.ssl993': 'SSL/TLS (typically port 993)',
    'admin.startTls143': 'STARTTLS (typically port 143)',
    'admin.imapDesc': "SMTP by itself does NOT save a copy of the sent message -- normally a mail client does that. Enable below so the app appends a copy to the Sent folder in your mailbox after every send (eQSL, notifications, password reset, etc.) -- you'll see in your mail client exactly what went out.",
    'admin.imapAppendCheckbox': 'Save a copy of sent mail in IMAP',
    'admin.imapHost': 'IMAP host',
    'admin.imapUser': 'IMAP user',
    'admin.imapUserPlaceholder': 'empty = same as SMTP',
    'admin.imapPassword': 'IMAP password',
    'admin.imapPasswordPlaceholder': 'empty = same as SMTP / enter to change',
    'admin.sentFolder': 'Sent folder',
    'admin.imapFolderNote': 'The folder name depends on the provider -- e.g. Gmail uses "[Gmail]/Sent Mail". If the user/password are left empty, the SMTP login above will be used (typical when it\'s the same mailbox).',
    'admin.telegramBotToken': 'Telegram Bot Token',
    'admin.discordSystemWebhook': 'Discord Webhook -- system notifications (new registrations)',
    'admin.webhookNote': "This is a SEPARATE webhook from the ones users set in the Watchlist tab (those are for personal DX alerts) -- this one sends notifications TO THE ADMIN about system events, e.g. new registrations.",
    'admin.registrationOpenLabel': 'New account registration open (disable for a private club instance -- accounts are then added by the admin manually/via SQL)',
    'admin.defaultPublicProfileLabel': 'New accounts default to a public profile enabled',
    'admin.loginRateLimitLabel': 'Login attempt limit (per IP address / 5 min)',
    'admin.maxQsosImportLabel': 'QSO limit per ADIF import',
    'admin.loggerDefaultsNote': "Applies only to FUTURE registrations -- does not change anything for existing users (each of them can still change this themselves in Account Settings).",
    'admin.defaultEqslLabel': 'New accounts default to automatic eQSL sending enabled on QSO save',
    'admin.inactivityNote': 'When a user hasn\'t logged in for the given number of days, they get an email reminder ("you haven\'t logged in for X days"). The next reminder only goes out after the same period elapses again, not daily -- it resets on the next login.',
    'admin.sendInactivityReminderLabel': 'Send inactivity reminder',
    'admin.inactivityThresholdLabel': 'Inactivity threshold (days)',
    'admin.maintenanceModeLabel': 'Enable maintenance mode (blocks login for regular users -- you as admin can still log in)',
    'admin.maintenanceMessageLabel': 'Message for users',
    'admin.maintenanceMessagePlaceholder': 'The service is temporarily unavailable -- back at 8:00 PM',
    'admin.debugWebsdrLabel': 'Collect diagnostic logs from the WebSDR tab (visible only to the admin, in the "🐛 Debug" tab)',
    'admin.debugWebsdrNote': 'When enabled, every attempt to load a WebSDR receiver (by any user) is logged -- receiver address, frequency/mode, whether it started, and detected causes of problems (e.g. http/https protocol mismatch). Disabled by default, to avoid collecting user activity data unnecessarily.',
    'admin.svxGroupsNote': 'The talkgroup list is visible to ALL users in the "🎙️ SVXLink" tab. Each group requires an Icecast/Shoutcast stream URL (e.g.',
    'admin.svxGroupsNote2': ') -- see the README, "SVXLink" section, for the recipe for a bridge from SVXLink to Icecast.',
    'admin.groupNamePlaceholder': 'Group name (e.g. TG91 PL)',
    'admin.groupDescPlaceholder': 'Description (optional)',
    'admin.adminNotifNote': 'Sent by email to',
    'admin.adminNotifNoteBold': 'all',
    'admin.adminNotifNote2': 'accounts with administrator permissions that have an email address set (not just to a single, hardcoded account). Requires SMTP configured above.',
    'admin.systemFeaturesNote': 'Global feature switches for all users. Disabling one pauses that feature system-wide (e.g. when you want to reduce load or SMTP has a problem).',
    'admin.termsNoteA': 'Publicly visible at',
    'admin.termsNoteB': '-- no login required, also reachable from the registration screen. The text below is a generated template -- adapt it to your installation (supports simple markdown:',
    'admin.termsNoteC': ',',
    'admin.termsNoteD': "). If you're offering the installation to a wider group of people, consider consulting a lawyer about GDPR compliance -- this is not a ready-made legal document.",
    'admin.markdownHeaderExample': '# heading',
    'admin.orgNameLabel': 'Club/organization name (optional)',
    'admin.contactEmailLabel': 'Contact email',
    'admin.appUrlLabel': 'App URL (for links in emails)',
    'admin.saveSettingsBtn': '✓ Save settings',
    'admin.sendTestEmailHeading': 'SEND A TEST EMAIL (check whether SMTP works):',
    'admin.sendTestBtn': '📤 Send test',
    'admin.newPasswordSetFor': 'New password set for',
    'admin.resetLinkSentTo': 'Reset link sent to',
    'admin.resetLinkGenFailed': 'Link generated, but sending the email failed (check SMTP)',
    'admin.errResetPassword': 'Error resetting password',
    'admin.sendResetEmail': 'Send link by email',
    'admin.setManually': 'Set manually',
    'admin.sendResetEmailInfo': 'Will send a standard password reset link to',
    'admin.smtpRequired': '(requires SMTP to be configured).',
    'admin.newPasswordLabel': 'New password',
    'admin.minChars': 'min. 6 characters',
    'admin.executeBtn': 'Execute',
    'admin.editAccountModalTitle': 'Account details',
    'admin.accountDataSaved': 'Account details for',
    'admin.savedSuffix': 'saved',
    'admin.errSave': 'Save error',
    'admin.editAccountInfo': "Direct change to account details -- e.g. fixing a typo in the callsign/email the user reported. Changing the callsign does NOT rewrite QSO history (DX station callsigns in the log stay unchanged).",
    'admin.callsignLabel': 'Callsign',
    'admin.emailLabel': 'Email',
    'admin.homeLocatorLat': 'Home locator -- lat.',
    'admin.homeLocatorLon': 'Home locator -- lon.',
    'admin.errLoadQsos': 'Error loading QSOs',
    'admin.qsoSaved': 'QSO saved',
    'admin.errSaveQso': 'Error saving QSO',
    'admin.confirmDeleteQso': 'Delete QSO',
    'admin.confirmDeleteQsoSuffix': '? It will go to the trash for 30 days.',
    'admin.qsoDeleted': 'QSO deleted (in trash for 30 days)',
    'admin.errDeleteQso': 'Error deleting QSO',
    'admin.noQsos': 'No QSOs',
    'admin.colDateTime': 'Date/Time',
    'admin.colBand': 'Band',
    'admin.colMode': 'Mode',
    'admin.colFreq': 'Freq.',
    'admin.colRst': 'RST S/R',
    'admin.bandAutoTitle': 'The band is calculated automatically from the frequency',
    'admin.freqAutoTitle': 'Changing the frequency automatically recalculates the band',
    'admin.prevPageShort': '‹ Previous',
    'admin.nextPageShort': 'Next ›',
    'admin.restoreBackupTitle': 'Restore backup',
    'admin.restoreWarning': 'This will OVERWRITE the entire current database with the contents of the file',
    'admin.restoreWarning2': 'Everything saved AFTER this backup date will be lost. This operation is irreversible (except by restoring from yet another backup). The app will briefly enter maintenance mode.',
    'admin.typeFilenameToConfirm': 'Type the exact filename to confirm',
    'admin.restoringInProgress': '⏳ Restoring...',
    'admin.restoreOverwriteBtn': 'Restore (overwrite database)',
    'admin.restoredSuccessfully': '✅ Restored successfully.',
    'admin.dbRestored': 'Database restored from backup',
    'admin.errRestore': 'Restore error',
    'admin.closeBtn': 'Close',
    'admin.resetPasswordTitle': 'Reset password',
    'admin.queueEmpty': 'The queue is empty — everything has been sent.',
    'admin.qsoSent': 'QSO sent!',
    'admin.offlineQueueTitle': 'Offline queue',
    'admin.offlineQueueDesc': 'QSOs saved locally (e.g. in the field, without internet), not yet sent to the database. If you see an error below on one of them -- the server REJECTED it (not a network issue) -- you can try resending it, or delete it and enter it manually in the form.',
    'admin.confirmDeleteQueueItem': 'Remove this QSO from the offline queue? It will not be saved to the log.',
    'admin.errStatus': 'Error',
    'admin.stillNoConnection': 'Still no connection to the server',
    'admin.failedToSend': 'Failed to send',
    'admin.noCallsign': '(no callsign)',
    'admin.retryBtn': '↻ Try to send',
    'admin.dismissAnnouncement': 'Dismiss this announcement',
    'admin.user': 'User',
    'admin.delete': 'Delete',
    'admin.featuresVisibleTo': 'The features below are visible to',
    'admin.regularUsers': 'regular users',
    'admin.adminsAlways': 'administrators always',
    'admin.enableWhenReady': '. Enable only once the feature is ready.',
    'admin.webSdrDiag': 'Collect diagnostic logs from the WebSDR tab',
    'mod.canSuspend': 'suspend/unsuspend regular accounts',
    // Completion -- all remaining
    'common.loadingSpots': '⏳ Loading spots...',
    'common.loadingNews': '⏳ Loading news...',
    'common.loadingRanking': '⏳ Loading ranking...',
    'common.loadingDxped': '⏳ Loading DXpeditions...',
    'common.loadingRepeaters': 'Loading repeaters...',
    'common.countingCountries': '⏳ Counting countries...',
    'common.clear': 'Clear',
    'common.range': 'Range:',
    'common.connecting': '○ connecting...',
    'common.upcoming': '📅 Upcoming',
    'common.sourceUnavailable': 'Source temporarily unavailable from the server.',
    'common.backToHamlogger': '← Back to HamLogger',
    'common.backToAccount': '← Back to your account',
    // eQSL
    'eqsl.markSent': '✓ Mark unsent as sent',
    'eqsl.markAsSent': 'Mark as sent',
    'eqsl.customBg': '🖼️ Custom background (optional)',
    'eqsl.removeBg': 'Remove background, back to colour',
    'eqsl.fieldPositions': '📍 Field positions',
    'eqsl.resetPositions': '↺ Restore default positions',
    'eqsl.bgSaved': 'eQSL background saved',
    'eqsl.usingCustomBg': 'A custom background is currently in use.',
    // CW
    'cw.decoder': 'CW decoder (listening)',
    'cw.startListening': 'Start listening',
    'cw.trainer': 'CW trainer',
    'cw.showAnswer': 'Show answer',
    'cw.customText': 'Custom text',
    'cw.practicing': 'Practising:',
    'cw.listenAndWrite': 'Listen and write down what you heard. Then click "Show answer".',
    // Profile / API
    'profile.hamProfile': 'Amateur radio profile',
    'profile.sessionSecurity': 'Session security',
    'profile.apiToken': 'Your API token',
    'profile.regenerate': 'Generate a new one (revokes the old)',
    'profile.revoke': 'Revoke',
    'profile.readOnly': 'read-only access to your own log',
    'profile.monthlySummary': 'Email me a monthly log summary',
    'profile.autoEqsl': 'Tick "Send eQSL" by default for new QSOs in the logger',
    'profile.emailOptional': 'Email address (optional -- if QRZ has no public one)',
    'profile.loadError': 'Error loading the profile -- please try again later.',
    'profile.actingAs': '🎭 Acting as',
    // Other
    'prop.whereToTx': 'Where to transmit now?',
    'prop.noBandData': 'No band condition data at the moment',
    'prop.rateRoute': 'Rate which band may be open on this path',
    'dxccmap.missingTop': '🎯 Most wanted entities you are missing',
    'dxccmap.openMostWanted': '💡 Open the "🏆 Most Wanted" tab to see which wanted countries you are missing.',
    'repeater.removeFav': 'Remove from favourites',
    'admin.firstAdmin': '🛠️ You have been automatically set as the first system administrator!',
    'live.httpWarning': '⚠️ This receiver uses http:// -- if you see an empty frame, open it in a new tab.',
  },
};

export const AVAILABLE_LANGUAGES = [
  { code: 'pl', label: 'Polski', flag: 'pl' },
  { code: 'en', label: 'English', flag: 'gb' },
];

// Jezyk: 1) wybrany RECZNIE (hamlogger_lang -- przelacznik jezyka albo
// ustawienie konta), 2) wykryty automatycznie (hamlogger_lang_auto): po znaku
// wywolawczym po zalogowaniu (polski prefiks -> pl, inny kraj -> en), a przed
// zalogowaniem po kraju adresu IP (/api/geo/lang), 3) jezyk przegladarki.
const LANG_KEY = 'hamlogger_lang';
const LANG_AUTO_KEY = 'hamlogger_lang_auto';

function readLang(key) {
  try {
    const v = localStorage.getItem(key);
    return v && TRANSLATIONS[v] ? v : null;
  } catch { return null; }   /* prywatny tryb przegladarki -- trudno */
}

function detectLanguage() {
  const chosen = readLang(LANG_KEY) || readLang(LANG_AUTO_KEY);
  if (chosen) return chosen;
  // Domyslnie polski (to polska aplikacja); angielski tylko gdy przegladarka
  // wyraznie nie jest polska.
  try {
    const nav = (navigator.language || 'pl').toLowerCase();
    if (!nav.startsWith('pl')) return 'en';
  } catch { /* ignoruj */ }
  return 'pl';
}

export function getLang() { return CURRENT_LANG; }
export function hasExplicitLang() { return !!readLang(LANG_KEY); }

function reloadForLang(next) {
  if (next === CURRENT_LANG) return false;
  CURRENT_LANG = next;
  if (typeof window !== 'undefined' && window.location && process.env.NODE_ENV !== 'test') window.location.reload();
  return true;
}

// Jezyk wykryty automatycznie -- NIE nadpisuje recznego wyboru.
export function applyAutoLanguage(next) {
  if (!TRANSLATIONS[next] || hasExplicitLang()) return false;
  try { localStorage.setItem(LANG_AUTO_KEY, next); } catch {}
  return reloadForLang(next);
}

// Jezyk zapisany na koncie (wybrany recznie) -- ma pierwszenstwo na kazdym urzadzeniu.
export function applyAccountLanguage(next) {
  if (!TRANSLATIONS[next]) return false;
  try { localStorage.setItem(LANG_KEY, next); } catch {}
  return reloadForLang(next);
}

// Pierwsza wizyta (brak wyboru i brak wykrycia): zanim cokolwiek sie narysuje,
// pytamy serwer o kraj adresu IP. Zwraca false, gdy strona sie przeladowuje
// (inny jezyk) -- wtedy nie renderujemy. Serwer nieosiagalny = bez zmian.
export async function initLanguage(apiBase = '', timeoutMs = 1500) {
  if (readLang(LANG_KEY) || readLang(LANG_AUTO_KEY)) return true;
  try {
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = setTimeout(() => ctrl && ctrl.abort(), timeoutMs);
    const r = await fetch(`${apiBase}/api/geo/lang`, { signal: ctrl ? ctrl.signal : undefined, cache: 'no-store' });
    clearTimeout(timer);
    const data = r.ok ? await r.json() : null;
    if (data && TRANSLATIONS[data.lang]) return !applyAutoLanguage(data.lang);
  } catch { /* offline / timeout -- zostaje jezyk przegladarki */ }
  return true;
}

// ── tx('polski tekst') -- tlumaczenie w stylu gettext ────────────────────────
// Kluczem jest sam polski tekst (widoczny w kodzie), angielskie odpowiedniki
// sa w i18n_en.js. Brak tlumaczenia = polski tekst (nigdy pusty ekran).
// Parametry: tx('Wysłano {0} QSO', [n]). Jezyk ustalany raz przy starcie --
// zmiana jezyka przeladowuje strone (teksty w stalych modulow tez sie zmienia).
let CURRENT_LANG = detectLanguage();

export function tx(text, args) {
  let out = text;
  if (CURRENT_LANG !== 'pl') {
    const tr = EN_TEXTS[text];
    if (tr !== undefined) out = tr;
  }
  if (args) out = out.replace(/\{(\d+)\}/g, (m, i) => (args[i] === undefined || args[i] === null ? '' : String(args[i])));
  return out;
}

const I18nContext = createContext({ lang: 'pl', setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);

  // Reczny wybor jezyka (zawsze wygrywa z wykrywaniem po IP/znaku).
  const setLang = useCallback((next) => {
    if (!TRANSLATIONS[next]) return;
    setLangState(next);
    try { localStorage.setItem(LANG_KEY, next); } catch {}
    // Teksty tx() (takze w stalych modulow) licza sie przy ladowaniu -- przeladuj
    reloadForLang(next);
  }, []);

  // t(klucz) -> tlumaczenie. Brak klucza -> zwracamy klucz (nie crash, nie
  // pusty string), wiec brakujace tlumaczenie jest widoczne, ale nieszkodliwe.
  const t = useCallback((key) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.pl;
    return dict[key] !== undefined ? dict[key] : (TRANSLATIONS.pl[key] !== undefined ? TRANSLATIONS.pl[key] : key);
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
